
import { newServices, newSpecialities } from "./NewData";

 //MARK: GET BY SERVICE ID
 export const getServiceById = (id) => {
  return newServices.find(service => service.id === id);
};

//MARK: GET BY Sepc ID
export const getSpecById = (id) => {
  return newSpecialities.find(spec => spec.id === id);
};





// export const dropDownServices = [
//   {
//     id:"arthritis",
//     title: "Arthritis",
//     link: "/services/arthritis",
//   },
//   {
//     id: "balance-training",
//     title: "Balance Training",
//     link: "/services/balance-training",
//   },
//   {
//     id: "gait-training",
//     title: "Gait Training",
//     link: "/services/gait-training",
//   },
//   {
//     id: "workplace-injuries",
//     title: "Workplace Injuries",
//     link: "/services/workplace-injuries",
//   },
//   {
//     id: "sciatica-pain",
//     title: "Sciatica Pain",
//     link: "/services/sciatica-pain",
//   },
//   {
//     id: "knee-pain",
//     title: "Knee Pain",
//     link: "/services/knee-pain",
//   },
//   {
//     id:"others",
//     title: "Additional Services",
//     link: "/services",
//   },
// ]


// //MARK: SERVICES
// export const services = [
//   {
//     id: "arthritis",
//     title: "Arthritis",
//     captionDescription:
//       "Effective arthritis treatment to reduce pain and improve mobility.",
//     description:
//       "Arthritis is a common condition that causes inflammation and pain in the joints, often leading to stiffness and reduced mobility. This chronic disease affects millions globally and can worsen over time if not properly managed. While arthritis is most common in older adults, it can impact people of all ages. Early diagnosis, medication, physical therapy, and lifestyle changes are crucial for managing symptoms and improving quality of life. Proper care helps prevent joint damage and maintain mobility.",
//     image: servicesImages.arthritis,
//     link: "/services/arthritis",
//     causes: [
//       {
//         title: "Inflammation of Joints",
//         description:
//           "Chronic inflammation results in joint pain, swelling, and stiffness. Left untreated, it can lead to joint deformities and loss of mobility.",
//       },
//       {
//         title: "Wear and Tear of Cartilage",
//         description:
//           "The gradual erosion of cartilage in joints causes bone friction, leading to swelling, stiffness, and pain.",
//       },
//       {
//         title: "Autoimmune Conditions",
//         description:
//           "In rheumatoid arthritis, the immune system mistakenly attacks joint tissues, causing severe inflammation and joint deformity if untreated.",
//       },
//       {
//         title: "Infections",
//         description:
//           "Certain infections can invade joints, causing intense inflammation and joint pain. Quick treatment prevents lasting joint damage.",
//       },
//       {
//         title: "Genetic Factors",
//         description:
//           "A family history of arthritis increases susceptibility, making joints more prone to inflammation and damage over time.",
//       },
//       {
//         title: "Obesity",
//         description:
//           "Excess body weight puts pressure on joints, accelerating cartilage breakdown and increasing the risk of arthritis.",
//       },
//     ],
//     management: [
//       {
//         title: "Medication",
//         description:
//           "Pain relievers and anti-inflammatory drugs help reduce inflammation, relieve pain, and slow disease progression.",
//       },
//       {
//         title: "Physical Therapy",
//         description:
//           "Regular physical therapy strengthens muscles around joints, improves flexibility, and helps restore mobility.",
//       },
//       {
//         title: "Lifestyle Modifications",
//         description:
//           "Diet changes, weight management, and gentle exercise help reduce symptoms and prevent further joint damage.",
//       },
//       {
//         title: "Assistive Devices",
//         description:
//           "Using walking aids like canes or braces can reduce joint strain and enhance daily mobility.",
//       },
//       {
//         title: "Heat and Cold Therapy",
//         description:
//           "Applying heat can relax muscles, while cold packs reduce swelling and numb painful areas.",
//       },
//       {
//         title: "Surgical Intervention",
//         description:
//           "In severe cases, joint replacement surgery may be necessary to restore joint function and reduce pain.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Aditya Shashtri",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapist)",
//         experience: "18 years of experience",
//         tags: ["Knee Pain", "Hip Pain", "Ligament and Sports surgeries"],
//         image: doctorHomeImages.doctor4,
//       },
//       {
//         name: "Dr. Paul Sidhu",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapist)",
//         experience: "19 years of experience",
//         tags: ["Shoulder Pain", "Back Pain", "Knee Pain", "+1"],
//         image: doctorHomeImages.doctor6,
//       },
//       {
//         name: "DR. Gargi Naha",
//         specialization: "Physiotherapist",
//         degree: "MPTh (Ortho)",
//         experience: "14 years of experience",
//         tags: ["Sports Injury", "Back Pain", "Neck Pain", "+3"],
//         image: doctorHomeImages.doctor5,
//       },
//     ],
//     causeImage: servicesImages.arthritisCause,
//   },
//   {
//     id: "balance-training",
//     title: "Balance Training",
//     captionDescription: "Boost balance and prevent falls.",
//     description:
//       "Balance training focuses on improving stability, strength, and coordination to reduce fall risk, particularly for the elderly or those with neurological conditions. It includes exercises targeting core muscles, enhancing postural control, and enabling safer mobility. This therapy is essential for those recovering from surgery, dealing with muscle weakness, or wanting to prevent fall-related injuries. Balance training promotes better daily function and independence.",
//     image: servicesImages.balancetraining,
//     link: "/services/balance-training",
//     causes: [
//       {
//         title: "Inner Ear Disorders",
//         description:
//           "Conditions like vertigo and vestibular disorders affect balance, causing dizziness and unsteadiness.",
//       },
//       {
//         title: "Muscle Weakness",
//         description:
//           "Weak muscles in the legs or core can make it harder to maintain balance and increase fall risks.",
//       },
//       {
//         title: "Poor Vision",
//         description:
//           "Vision problems affect spatial awareness, increasing the chance of tripping or falling.",
//       },
//       {
//         title: "Neurological Conditions",
//         description:
//           "Conditions like stroke or Parkinson’s disease impact coordination, making balance harder to maintain.",
//       },
//       {
//         title: "Aging",
//         description:
//           "Age-related decline in strength and mobility leads to poor balance and greater fall risk.",
//       },
//       {
//         title: "Medications",
//         description:
//           "Certain medications cause dizziness, lightheadedness, or unsteady movements.",
//       },
//     ],
//     management: [
//       {
//         title: "Balance Exercises",
//         description:
//           "Exercises that focus on core strength and posture improve stability and reduce fall risk.",
//       },
//       {
//         title: "Strength Training",
//         description:
//           "Improving muscle strength, particularly in the legs, helps with better overall balance.",
//       },
//       {
//         title: "Vision Correction",
//         description:
//           "Addressing vision problems, like using glasses, can prevent missteps and falls.",
//       },
//       {
//         title: "Assistive Devices",
//         description:
//           "Devices like canes and walkers help individuals maintain balance during daily activities.",
//       },
//       {
//         title: "Physical Therapy",
//         description:
//           "Therapy helps with balance retraining and teaches techniques to prevent falls.",
//       },
//       {
//         title: "Home Modifications",
//         description:
//           "Making changes like installing grab bars or removing tripping hazards improves safety.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Robert Brown",
//         specialization: "Neurological Physiotherapist",
//         degree: "MPT (Neuro)",
//         experience: "12 years of experience",
//         tags: [
//           "Balance Issues",
//           "Vestibular Disorders",
//           "Stroke Rehabilitation",
//         ],
//         image: doctorHomeImages.doctor1,
//       },
//       {
//         name: "Dr. Emily Green",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "10 years of experience",
//         tags: ["Gait Training", "Mobility Improvement", "Senior Care"],
//         image: doctorHomeImages.doctor2,
//       },
//       {
//         name: "Dr. Sarah Lee",
//         specialization: "Physiotherapist",
//         degree: "DPT",
//         experience: "15 years of experience",
//         tags: [
//           "Neurological Conditions",
//           "Vestibular Disorders",
//           "Parkinson’s Disease",
//         ],
//         image: doctorHomeImages.doctor3,
//       },
//     ],
//     causeImage: servicesImages.balanceTrainingCause,
//   },

//   {
//     id: "gait-training",
//     title: "Gait Training",
//     captionDescription: "Improve walking patterns with specialized therapy.",
//     description:
//       "Gait training helps individuals improve their walking ability by addressing muscle weakness, joint stiffness, or neurological conditions. It focuses on retraining walking patterns, increasing balance, and strengthening leg muscles. This therapy is particularly beneficial for people recovering from surgery, injury, or neurological events like stroke, enhancing mobility and reducing the risk of falls. The goal is to restore a more natural and effective walking pattern.",
//     image: servicesImages.gaittraining,
//     link: "/services/gait-training",
//     causes: [
//       {
//         title: "Stroke",
//         description:
//           "A stroke can cause weakness on one side of the body, affecting balance and mobility.",
//       },
//       {
//         title: "Spinal Cord Injury",
//         description:
//           "Injury to the spinal cord can result in paralysis or weakness in the legs, impacting walking.",
//       },
//       {
//         title: "Multiple Sclerosis",
//         description:
//           "MS causes muscle weakness, coordination issues, and mobility challenges.",
//       },
//       {
//         title: "Arthritis",
//         description:
//           "Joint pain and stiffness from arthritis can limit range of motion and walking ability.",
//       },
//       {
//         title: "Parkinson’s Disease",
//         description:
//           "This neurological condition affects coordination and muscle control, making walking difficult.",
//       },
//       {
//         title: "Injuries",
//         description:
//           "Trauma to the legs, hips, or spine can disrupt normal walking patterns.",
//       },
//     ],
//     management: [
//       {
//         title: "Physical Therapy",
//         description:
//           "Therapists use exercises and techniques to help retrain muscles and improve walking.",
//       },
//       {
//         title: "Assistive Devices",
//         description:
//           "Canes, walkers, and braces can assist with mobility and reduce strain.",
//       },
//       {
//         title: "Strengthening Exercises",
//         description:
//           "Building leg strength improves overall walking ability and reduces injury risk.",
//       },
//       {
//         title: "Range of Motion Exercises",
//         description:
//           "Stretching and joint mobilization help restore normal movement and function.",
//       },
//       {
//         title: "Orthotic Devices",
//         description:
//           "Custom orthotics can help improve foot alignment and walking mechanics.",
//       },
//       {
//         title: "Surgery",
//         description:
//           "In severe cases, surgical intervention may be necessary to correct alignment or function.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Laura Smith",
//         specialization: "Physiotherapist",
//         degree: "DPT",
//         experience: "15 years of experience",
//         tags: [
//           "Stroke Rehabilitation",
//           "Gait Training",
//           "Neurological Conditions",
//         ],
//         image: doctorHomeImages.doctor4,
//       },
//       {
//         name: "Dr. Michael Johnson",
//         specialization: "Orthopedic Specialist",
//         degree: "MPT (Ortho)",
//         experience: "18 years of experience",
//         tags: ["Spinal Cord Injuries", "Muscle Weakness", "Joint Replacements"],
//         image: doctorHomeImages.doctor5,
//       },
//       {
//         name: "Dr. Sarah Brown",
//         specialization: "Neurological Physiotherapist",
//         degree: "MPT (Neuro)",
//         experience: "20 years of experience",
//         tags: ["Multiple Sclerosis", "Stroke Recovery", "Balance Training"],
//         image: doctorHomeImages.doctor6,
//       },
//     ],
//     causeImage: servicesImages.gaitTrainingCause,
//   },
//   {
//     id: "headaches",
//     title: "Headaches",
//     captionDescription: "Relieve headache pain effectively.",
//     description:
//       "Headaches can be caused by a variety of factors, including tension, sinus pressure, and migraines. They can range from mild discomfort to severe pain that impacts daily activities. Identifying the root cause is essential for proper treatment. With the right combination of pain management, stress reduction, and lifestyle changes, headaches can be effectively managed and their frequency reduced, allowing for a better quality of life.",
//     image: servicesImages.headaches,
//     link: "/services/headaches",
//     causes: [
//       {
//         title: "Tension Headaches",
//         description:
//           "Tight muscles in the neck and shoulders can cause tension headaches, leading to pressure and pain around the forehead.",
//       },
//       {
//         title: "Migraines",
//         description:
//           "Migraines are severe, throbbing headaches often accompanied by nausea and sensitivity to light and sound.",
//       },
//       {
//         title: "Sinus Infections",
//         description:
//           "Inflammation in the sinus cavities can cause pain around the eyes and nose, resulting in sinus headaches.",
//       },
//     ],
//     management: [
//       {
//         title: "Pain Relief Medication",
//         description:
//           "Over-the-counter or prescribed medications help alleviate headache symptoms and reduce pain.",
//       },
//       {
//         title: "Stress Management",
//         description:
//           "Relaxation techniques and stress management can help reduce the frequency of tension headaches.",
//       },
//       {
//         title: "Physical Therapy",
//         description:
//           "Therapies like massage and heat application can help relieve tension in the neck and shoulders, reducing headache frequency.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Laura Martinez",
//         specialization: "Neurologist",
//         degree: "M.D.",
//         experience: "12 years of experience",
//         tags: ["Headaches", "Migraines", "Neurology"],
//         image: doctorHomeImages.doctor7,
//       },
//       {
//         name: "Dr. Kevin Brown",
//         specialization: "Pain Management Specialist",
//         degree: "M.D.",
//         experience: "10 years of experience",
//         tags: ["Chronic Pain", "Headache Treatment", "Stress Management"],
//         image: doctorHomeImages.doctor8,
//       },
//     ],
//     causeImage: servicesImages.headachesCause,
//   },
//   {
//     id: "neck-pain",
//     title: "Neck Pain",
//     captionDescription: "Alleviate neck pain and improve mobility.",
//     description:
//       "Neck pain can stem from poor posture, injuries, or degenerative conditions. This pain often limits neck movement and affects daily tasks like driving or sitting comfortably. Neck pain management focuses on reducing discomfort, improving posture, and strengthening muscles around the neck. By addressing the root causes, therapy can help restore mobility and prevent further issues. Early intervention can minimize the impact on daily activities.",
//     image: servicesImages.neck,
//     link: "/services/neck-pain",
//     causes: [
//       {
//         title: "Poor Posture",
//         description:
//           "Slouching or sitting with poor posture can strain the muscles and ligaments of the neck.",
//       },
//       {
//         title: "Whiplash",
//         description:
//           "Sudden movement of the head can cause strain or injury to the neck muscles and ligaments, leading to pain.",
//       },
//       {
//         title: "Arthritis",
//         description:
//           "Degenerative conditions like arthritis can lead to neck stiffness and discomfort over time.",
//       },
//     ],
//     management: [
//       {
//         title: "Physical Therapy",
//         description:
//           "Therapy includes stretches and exercises to strengthen muscles and improve posture.",
//       },
//       {
//         title: "Ergonomic Adjustments",
//         description:
//           "Changing workstations to promote good posture can help reduce strain on the neck.",
//       },
//       {
//         title: "Heat Therapy",
//         description:
//           "Applying heat to the affected area helps relax tense muscles and improve blood flow.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Emily Davis",
//         specialization: "Orthopedic Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "15 years of experience",
//         tags: ["Neck Pain", "Posture Correction", "Whiplash Treatment"],
//         image: doctorHomeImages.doctor9,
//       },
//       {
//         name: "Dr. James Wilson",
//         specialization: "Physiotherapist",
//         degree: "DPT",
//         experience: "18 years of experience",
//         tags: ["Arthritis Management", "Neck Pain", "Spinal Therapy"],
//         image: doctorHomeImages.doctor10,
//       },
//     ],
//     causeImage: servicesImages.neckPainCause,
//   },
//   {
//     id: "motor-vehicle-accidents",
//     title: "Motor Vehicle Accidents",
//     captionDescription: "Recover fully after a motor vehicle accident.",
//     description:
//       "Motor vehicle accidents often result in various injuries, including whiplash, fractures, and soft tissue damage. These injuries can significantly impact daily activities and quality of life. Effective rehabilitation focuses on restoring mobility, reducing pain, and strengthening muscles to support recovery. A personalized treatment plan helps patients regain full function and prevents long-term complications associated with accident injuries.",
//     image: servicesImages.accident,
//     link: "/services/motor-vehicle-accidents",
//     causes: [
//       {
//         title: "Whiplash",
//         description:
//           "The sudden jolt of the neck during a car accident can cause strain on the neck muscles and ligaments.",
//       },
//       {
//         title: "Fractures",
//         description:
//           "The impact of a car accident can result in bone fractures, particularly in the arms, legs, or ribs.",
//       },
//       {
//         title: "Soft Tissue Injuries",
//         description:
//           "Damage to muscles, tendons, and ligaments often occurs during accidents, causing pain and restricted movement.",
//       },
//     ],
//     management: [
//       {
//         title: "Physical Therapy",
//         description:
//           "Therapy helps restore movement and flexibility after accident-related injuries.",
//       },
//       {
//         title: "Pain Management",
//         description:
//           "Medication and treatments help control pain during the healing process.",
//       },
//       {
//         title: "Rehabilitation Exercises",
//         description:
//           "Strengthening exercises support recovery by rebuilding muscle strength and endurance.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Paul Sidhu",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "10 years of experience",
//         tags: [
//           "Motor Vehicle Accidents",
//           "Rehabilitation",
//           "Whiplash Treatment",
//         ],
//         image: doctorHomeImages.doctor11,
//       },
//       {
//         name: "Dr. Gargi Naha",
//         specialization: "Orthopedic Physiotherapist",
//         degree: "MPTh (Ortho)",
//         experience: "14 years of experience",
//         tags: [
//           "Fracture Recovery",
//           "Motor Vehicle Accidents",
//           "Soft Tissue Injuries",
//         ],
//         image: doctorHomeImages.doctor12,
//       },
//     ],
//     causeImage: servicesImages.motorVehicleAccidentsCause,
//   },
//   {
//     id: "workplace-injuries",
//     title: "Workplace Injuries",
//     captionDescription:
//       "Recover quickly from workplace injuries and prevent re-injury.",
//     description:
//       "Workplace injuries can range from minor strains to serious musculoskeletal injuries. These injuries often affect productivity and quality of life if not properly treated. Physical rehabilitation focuses on relieving pain, restoring function, and preventing re-injury. Early intervention and tailored treatment programs help injured employees return to work safely and reduce the risk of future injuries. With proper care, individuals can regain strength and mobility.",
//     image: servicesImages.workplacehealth,
//     link: "/services/workplace-injuries",
//     causes: [
//       {
//         title: "Overexertion",
//         description:
//           "Lifting or pushing heavy objects can cause overexertion, leading to muscle strains, particularly in the back.",
//       },
//       {
//         title: "Repetitive Strain",
//         description:
//           "Performing repetitive tasks can lead to strain on muscles, tendons, and ligaments, causing conditions like carpal tunnel syndrome.",
//       },
//       {
//         title: "Slip and Fall",
//         description:
//           "Slips, trips, and falls in the workplace can cause sprains, fractures, and soft tissue injuries.",
//       },
//       {
//         title: "Equipment Injuries",
//         description:
//           "Improper handling or malfunctioning of machinery can lead to cuts, fractures, or other severe injuries.",
//       },
//       {
//         title: "Postural Strain",
//         description:
//           "Poor posture during desk work or prolonged standing can cause neck, back, and shoulder pain.",
//       },
//       {
//         title: "Fatigue",
//         description:
//           "Excessive fatigue due to overwork can increase the risk of injury by reducing coordination and strength.",
//       },
//     ],
//     management: [
//       {
//         title: "Physical Therapy",
//         description:
//           "Targeted exercises and therapies help restore mobility, strength, and function after workplace injuries.",
//       },
//       {
//         title: "Ergonomic Assessments",
//         description:
//           "Modifying workstations to reduce strain can help prevent further injury and improve posture.",
//       },
//       {
//         title: "Stretching Exercises",
//         description:
//           "Incorporating regular stretching helps improve flexibility and prevent muscle stiffness.",
//       },
//       {
//         title: "Manual Therapy",
//         description:
//           "Techniques such as massage and joint mobilization relieve tension and restore normal joint movement.",
//       },
//       {
//         title: "Pain Management",
//         description:
//           "Medications and therapeutic modalities are used to alleviate pain during recovery.",
//       },
//       {
//         title: "Return-to-Work Programs",
//         description:
//           "Customized programs help safely transition individuals back to work after injury.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Paul Sidhu",
//         specialization: "Occupational Therapist",
//         degree: "M.Sc (Occupational Therapy)",
//         experience: "10 years of experience",
//         tags: ["Workplace Injuries", "Rehabilitation", "Ergonomics"],
//         image: doctorHomeImages.doctor13,
//       },
//       {
//         name: "Dr. Gargi Naha",
//         specialization: "Physiotherapist",
//         degree: "MPTh (Ortho)",
//         experience: "14 years of experience",
//         tags: ["Postural Strain", "Ergonomics", "Injury Prevention"],
//         image: doctorHomeImages.doctor12,
//       },
//       {
//         name: "Dr. Mark Taylor",
//         specialization: "Rehabilitation Specialist",
//         degree: "M.D.",
//         experience: "18 years of experience",
//         tags: ["Workplace Injuries", "Rehabilitation", "Manual Therapy"],
//         image: doctorHomeImages.doctor14,
//       },
//     ],
//     causeImage: servicesImages.workplaceInjuriesCause,
//   },

//   {
//     id: "neurological-disorders",
//     title: "Neurological Disorders",
//     captionDescription:
//       "Rehabilitation for neurological conditions and movement recovery.",
//     description:
//       "Neurological disorders such as stroke, multiple sclerosis, and Parkinson’s disease can severely impact movement, coordination, and daily function. Specialized rehabilitation focuses on retraining the brain and muscles to restore mobility, balance, and strength. By improving motor control and physical function, rehabilitation can help patients with neurological disorders regain independence, manage symptoms, and enhance quality of life.",
//     image: servicesImages.neurologicaldisorder,
//     link: "/services/neurological-disorders",
//     causes: [
//       {
//         title: "Stroke",
//         description:
//           "A stroke can result in damage to the brain, causing muscle weakness, impaired coordination, and difficulty with movement.",
//       },
//       {
//         title: "Parkinson’s Disease",
//         description:
//           "This progressive neurological condition causes tremors, stiffness, and difficulty with balance and movement.",
//       },
//       {
//         title: "Multiple Sclerosis",
//         description:
//           "MS affects the nervous system, leading to muscle weakness, balance issues, and coordination problems.",
//       },
//       {
//         title: "Traumatic Brain Injury",
//         description:
//           "Injury to the brain due to trauma can impair movement, speech, and cognitive function.",
//       },
//       {
//         title: "Cerebral Palsy",
//         description:
//           "A congenital disorder affecting muscle tone, movement, and coordination, often caused by brain damage before or at birth.",
//       },
//       {
//         title: "Spinal Cord Injury",
//         description:
//           "Damage to the spinal cord can result in partial or complete paralysis, affecting mobility and bodily function.",
//       },
//     ],
//     management: [
//       {
//         title: "Neurorehabilitation",
//         description:
//           "Therapies aimed at restoring movement and motor control through retraining of the nervous system.",
//       },
//       {
//         title: "Physical Therapy",
//         description:
//           "Exercises to strengthen muscles, improve mobility, and restore function after neurological damage.",
//       },
//       {
//         title: "Speech Therapy",
//         description:
//           "Helps restore speech and communication abilities impaired by neurological disorders.",
//       },
//       {
//         title: "Occupational Therapy",
//         description:
//           "Assists patients in adapting to daily tasks and regaining independence despite neurological impairment.",
//       },
//       {
//         title: "Assistive Devices",
//         description:
//           "Use of walkers, wheelchairs, or braces to aid mobility and independence in daily life.",
//       },
//       {
//         title: "Medications",
//         description:
//           "Medications help manage symptoms such as muscle stiffness, pain, or spasms common in neurological conditions.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Sarah Lee",
//         specialization: "Neurologist",
//         degree: "M.D.",
//         experience: "16 years of experience",
//         tags: [
//           "Neurological Disorders",
//           "Rehabilitation",
//           "Neurorehabilitation",
//         ],
//         image: doctorHomeImages.doctor15,
//       },
//       {
//         name: "Dr. James Wilson",
//         specialization: "Physiotherapist",
//         degree: "DPT",
//         experience: "12 years of experience",
//         tags: [
//           "Stroke Recovery",
//           "Neurological Rehabilitation",
//           "Mobility Issues",
//         ],
//         image: doctorHomeImages.doctor16,
//       },
//       {
//         name: "Dr. Laura Martinez",
//         specialization: "Speech Therapist",
//         degree: "M.Sc (Speech Therapy)",
//         experience: "14 years of experience",
//         tags: [
//           "Speech Disorders",
//           "Cognitive Rehabilitation",
//           "Neurological Disorders",
//         ],
//         image: doctorHomeImages.doctor17,
//       },
//     ],
//     causeImage: servicesImages.neurologicalDisordersCause,
//   },
//   {
//     id: "vertigo",
//     title: "Vertigo",
//     captionDescription: "Treat vertigo and regain balance.",
//     description:
//       "Vertigo is a sensation of spinning or dizziness that affects balance and coordination. It is often caused by problems in the inner ear or the vestibular system. Vertigo can make it difficult to perform daily activities, causing nausea and disorientation. Specialized treatments focus on resolving the underlying cause of vertigo and restoring balance through vestibular rehabilitation and exercises designed to improve coordination and reduce dizziness.",
//     image: servicesImages.vertigo,
//     link: "/services/vertigo",
//     causes: [
//       {
//         title: "Benign Paroxysmal Positional Vertigo (BPPV)",
//         description:
//           "A common inner ear disorder where small particles in the ear canal cause dizziness and imbalance.",
//       },
//       {
//         title: "Meniere’s Disease",
//         description:
//           "A disorder of the inner ear that causes vertigo, hearing loss, and ringing in the ears.",
//       },
//       {
//         title: "Labyrinthitis",
//         description:
//           "Inflammation of the inner ear labyrinth that can cause vertigo and imbalance.",
//       },
//       {
//         title: "Vestibular Neuritis",
//         description:
//           "An infection of the vestibular nerve causing sudden, severe vertigo.",
//       },
//       {
//         title: "Migraines",
//         description:
//           "Some migraines can trigger vertigo symptoms alongside the headache.",
//       },
//       {
//         title: "Head Injury",
//         description:
//           "Trauma to the head can cause vestibular damage, leading to vertigo.",
//       },
//     ],
//     management: [
//       {
//         title: "",
//       },
//     ],
//   },
//   {
//     id: "dizziness",
//     title: "Dizziness",
//     captionDescription: "Recover from dizziness with targeted therapy.",
//     description:
//       "Dizziness is a common symptom that often occurs due to issues with the inner ear, low blood pressure, or dehydration. It can range from lightheadedness to a feeling of spinning or loss of balance. This can disrupt daily activities and increase the risk of falls, especially in older adults. Treatment often involves identifying the underlying cause, along with exercises to restore balance and improve coordination, helping to regain confidence and stability.",
//     image: servicesImages.vertigo,
//     link: "/services/dizziness",
//     causes: [
//       {
//         title: "Low Blood Pressure",
//         description:
//           "Sudden drops in blood pressure can cause lightheadedness, dizziness, and fainting spells.",
//       },
//       {
//         title: "Inner Ear Issues",
//         description:
//           "Conditions like vestibular neuritis or labyrinthitis can disrupt balance and cause dizziness.",
//       },
//       {
//         title: "Dehydration",
//         description:
//           "Lack of fluids in the body can cause dizziness and impair balance.",
//       },
//       {
//         title: "Medications",
//         description:
//           "Certain drugs, especially blood pressure medications, may cause dizziness as a side effect.",
//       },
//       {
//         title: "Anxiety",
//         description:
//           "Anxiety and panic attacks can lead to dizziness, hyperventilation, and lightheadedness.",
//       },
//       {
//         title: "Vestibular Disorders",
//         description:
//           "Inner ear disorders affecting the vestibular system can result in chronic dizziness.",
//       },
//     ],
//     management: [
//       {
//         title: "Vestibular Therapy",
//         description:
//           "Exercises to retrain the brain and improve balance, reducing dizziness.",
//       },
//       {
//         title: "Hydration",
//         description:
//           "Maintaining proper hydration can prevent dizziness caused by dehydration.",
//       },
//       {
//         title: "Balance Training",
//         description:
//           "Improves coordination and reduces the risk of falls through targeted exercises.",
//       },
//       {
//         title: "Medication Adjustment",
//         description:
//           "Reviewing and adjusting medications to reduce dizziness side effects.",
//       },
//       {
//         title: "Posture Improvement",
//         description:
//           "Proper posture reduces the risk of dizziness caused by blood pressure changes.",
//       },
//       {
//         title: "Breathing Exercises",
//         description:
//           "Relaxation and breathing techniques help manage anxiety-related dizziness.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Sarah Lee",
//         specialization: "Vestibular Therapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "10 years of experience",
//         tags: ["Dizziness", "Vestibular Disorders", "Balance Therapy"],
//         image: doctorHomeImages.doctor16,
//       },
//       {
//         name: "Dr. James Wilson",
//         specialization: "Neurologist",
//         degree: "M.D.",
//         experience: "12 years of experience",
//         tags: ["Dizziness", "Neurological Disorders", "Inner Ear Issues"],
//         image: doctorHomeImages.doctor17,
//       },
//       {
//         name: "Dr. Laura Martinez",
//         specialization: "Rehabilitation Specialist",
//         degree: "M.D.",
//         experience: "14 years of experience",
//         tags: ["Dizziness", "Balance Training", "Postural Therapy"],
//         image: doctorHomeImages.doctor18,
//       },
//     ],
//     causeImage: servicesImages.dizzinessCause,
//   },

//   {
//     id: "back-pain",
//     title: "Back Pain",
//     captionDescription: "Alleviate back pain and restore mobility.",
//     description:
//       "Back pain is one of the most common reasons people seek medical attention. It can be caused by muscle strain, herniated discs, or poor posture, and often results in discomfort or limited movement. Addressing back pain early through targeted exercises, posture correction, and lifestyle modifications can prevent long-term disability. A well-designed physical therapy program can restore mobility, improve strength, and alleviate pain, allowing individuals to return to normal daily activities.",
//     image: servicesImages.musculoskelethalhealth,
//     link: "/services/back-pain",
//     causes: [
//       {
//         title: "Muscle Strain",
//         description:
//           "Overuse or sudden movement can cause muscle strain in the back, leading to pain.",
//       },
//       {
//         title: "Herniated Disc",
//         description:
//           "A herniated disc can press on nerves, causing significant pain and discomfort.",
//       },
//       {
//         title: "Poor Posture",
//         description:
//           "Improper sitting or standing posture can cause long-term back pain and discomfort.",
//       },
//       {
//         title: "Osteoarthritis",
//         description:
//           "Degeneration of the joints in the spine can lead to chronic back pain.",
//       },
//       {
//         title: "Injuries",
//         description:
//           "Traumatic events, like car accidents, can result in back injuries requiring treatment.",
//       },
//       {
//         title: "Scoliosis",
//         description:
//           "An abnormal curvature of the spine can lead to persistent back pain and discomfort.",
//       },
//     ],
//     management: [
//       {
//         title: "Physical Therapy",
//         description:
//           "Exercises aimed at improving strength, flexibility, and mobility to relieve pain.",
//       },
//       {
//         title: "Posture Correction",
//         description:
//           "Proper alignment of the spine can reduce pressure on the back and alleviate pain.",
//       },
//       {
//         title: "Manual Therapy",
//         description:
//           "Massage and manipulation techniques help reduce muscle tension and improve mobility.",
//       },
//       {
//         title: "Heat and Cold Therapy",
//         description:
//           "Alternating between heat and cold can help relieve inflammation and muscle soreness.",
//       },
//       {
//         title: "Stretching Exercises",
//         description:
//           "Incorporating stretching into daily routines helps prevent stiffness and improve flexibility.",
//       },
//       {
//         title: "Ergonomic Adjustments",
//         description:
//           "Modifying the workspace or sleeping position can help alleviate chronic back pain.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Aditya Shashtri",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "18 years of experience",
//         tags: ["Back Pain", "Posture Correction", "Manual Therapy"],
//         image: doctorHomeImages.doctor4,
//       },
//       {
//         name: "Dr. Paul Sidhu",
//         specialization: "Chiropractor",
//         degree: "D.C.",
//         experience: "14 years of experience",
//         tags: ["Spinal Alignment", "Back Injuries", "Posture Correction"],
//         image: doctorHomeImages.doctor5,
//       },
//       {
//         name: "Dr. Sarah Lee",
//         specialization: "Orthopedic Surgeon",
//         degree: "M.D.",
//         experience: "12 years of experience",
//         tags: ["Back Surgery", "Spinal Disorders", "Rehabilitation"],
//         image: doctorHomeImages.doctor6,
//       },
//     ],
//     causeImage: servicesImages.backPainCause,
//   },

//   {
//     id: "sciatica-pain",
//     title: "Sciatica Pain",
//     captionDescription: "Effective relief for sciatica pain.",
//     description:
//       "Sciatica refers to pain that radiates along the path of the sciatic nerve, which extends from the lower back down through the hips and legs. It often occurs when a herniated disc or bone spur compresses part of the nerve, leading to inflammation and pain. Symptoms include sharp, shooting pain, numbness, and tingling in the affected leg. Physical therapy, medications, and targeted exercises can provide relief and prevent the condition from worsening.",
//     image: servicesImages.sciatica,
//     link: "/services/sciatica-pain",
//     causes: [
//       {
//         title: "Herniated Disc",
//         description:
//           "A displaced disc in the spine presses on the sciatic nerve, causing intense pain.",
//       },
//       {
//         title: "Bone Spurs",
//         description:
//           "Bony growths in the spine can compress the sciatic nerve, leading to pain and discomfort.",
//       },
//       {
//         title: "Spinal Stenosis",
//         description:
//           "Narrowing of the spine places pressure on the sciatic nerve, resulting in pain.",
//       },
//       {
//         title: "Piriformis Syndrome",
//         description:
//           "The piriformis muscle irritates the sciatic nerve, causing pain down the leg.",
//       },
//       {
//         title: "Injury",
//         description:
//           "Trauma to the lower back or pelvis can lead to sciatic nerve damage.",
//       },
//       {
//         title: "Pregnancy",
//         description:
//           "The weight of the baby can press on the sciatic nerve, leading to pain in the lower back and leg.",
//       },
//     ],
//     management: [
//       {
//         title: "Physical Therapy",
//         description:
//           "Exercises aimed at strengthening muscles and reducing pressure on the sciatic nerve.",
//       },
//       {
//         title: "Stretching Exercises",
//         description:
//           "Targeted stretches can alleviate tension in muscles around the sciatic nerve.",
//       },
//       {
//         title: "Medications",
//         description:
//           "Anti-inflammatory drugs and pain relievers can reduce pain and inflammation.",
//       },
//       {
//         title: "Heat and Cold Therapy",
//         description:
//           "Applying heat or cold packs can help soothe inflamed muscles and alleviate pain.",
//       },
//       {
//         title: "Posture Correction",
//         description:
//           "Proper sitting and standing posture can relieve pressure on the sciatic nerve.",
//       },
//       {
//         title: "Epidural Steroid Injections",
//         description:
//           "In severe cases, injections can reduce inflammation and alleviate pain.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Emily Davis",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "15 years of experience",
//         tags: ["Sciatica", "Spinal Disorders", "Posture Correction"],
//         image: doctorHomeImages.doctor1,
//       },
//       {
//         name: "Dr. Paul Sidhu",
//         specialization: "Chiropractor",
//         degree: "D.C.",
//         experience: "19 years of experience",
//         tags: ["Sciatica Pain", "Spinal Manipulation", "Nerve Pain"],
//         image: doctorHomeImages.doctor6,
//       },
//       {
//         name: "Dr. Sarah Lee",
//         specialization: "Orthopedic Surgeon",
//         degree: "M.D.",
//         experience: "14 years of experience",
//         tags: ["Sciatica", "Spinal Surgery", "Rehabilitation"],
//         image: doctorHomeImages.doctor16,
//       },
//     ],
//     causeImage: servicesImages.sciaticaCause,
//   },
//   {
//     id: "shoulder-pain",
//     title: "Shoulder Pain",
//     captionDescription: "Recover from shoulder pain and regain mobility.",
//     description:
//       "Shoulder pain can occur from various causes, such as overuse, injury, or underlying conditions like arthritis. This pain can affect daily activities, limiting range of motion and strength. Addressing shoulder pain early with physical therapy, strength training, and targeted exercises can improve recovery outcomes and prevent further injury. Treatment focuses on restoring mobility, reducing inflammation, and improving strength, allowing individuals to return to normal activities without pain.",
//     image: servicesImages.shoulder,
//     link: "/services/shoulder-pain",
//     causes: [
//       {
//         title: "Rotator Cuff Tear",
//         description:
//           "A tear in the rotator cuff causes pain and limits shoulder movement.",
//       },
//       {
//         title: "Frozen Shoulder",
//         description:
//           "Stiffness and pain in the shoulder limit its range of motion.",
//       },
//       {
//         title: "Bursitis",
//         description:
//           "Inflammation of the bursae causes pain when moving the shoulder.",
//       },
//       {
//         title: "Tendinitis",
//         description:
//           "Inflammation of tendons due to overuse leads to shoulder pain.",
//       },
//       {
//         title: "Dislocation",
//         description:
//           "When the shoulder joint is dislocated, it can cause severe pain and instability.",
//       },
//       {
//         title: "Arthritis",
//         description:
//           "Inflammation in the shoulder joint leads to chronic pain and stiffness.",
//       },
//     ],
//     management: [
//       {
//         title: "Physical Therapy",
//         description:
//           "Strength and flexibility exercises improve shoulder function and alleviate pain.",
//       },
//       {
//         title: "Corticosteroid Injections",
//         description:
//           "Steroid injections can reduce inflammation and relieve shoulder pain.",
//       },
//       {
//         title: "Heat and Cold Therapy",
//         description:
//           "Applying heat or cold packs helps reduce inflammation and soothe pain.",
//       },
//       {
//         title: "Manual Therapy",
//         description:
//           "Massage techniques help reduce muscle tension and improve shoulder mobility.",
//       },
//       {
//         title: "Stretching Exercises",
//         description:
//           "Targeted stretches can prevent stiffness and improve range of motion.",
//       },
//       {
//         title: "Surgical Intervention",
//         description:
//           "In severe cases, surgery may be required to repair torn tissues and restore function.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Robert Brown",
//         specialization: "Orthopedic Surgeon",
//         degree: "M.D.",
//         experience: "12 years of experience",
//         tags: ["Shoulder Surgery", "Rotator Cuff Repair", "Rehabilitation"],
//         image: doctorHomeImages.doctor19,
//       },
//       {
//         name: "Dr. Emily Davis",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "14 years of experience",
//         tags: ["Shoulder Pain", "Manual Therapy", "Post-Surgical Rehab"],
//         image: doctorHomeImages.doctor1,
//       },
//       {
//         name: "Dr. Laura Martinez",
//         specialization: "Chiropractor",
//         degree: "D.C.",
//         experience: "15 years of experience",
//         tags: [
//           "Shoulder Adjustments",
//           "Joint Pain Relief",
//           "Posture Correction",
//         ],
//         image: doctorHomeImages.doctor5,
//       },
//     ],
//     causeImage: servicesImages.shoulderPainCause,
//   },
//   {
//     id: "hip-pain",
//     title: "Hip Pain",
//     captionDescription: "Effective hip pain treatment to restore mobility.",
//     description:
//       "Hip pain can significantly impact mobility and quality of life. This discomfort may result from injury, overuse, or chronic conditions like arthritis. Common symptoms include stiffness, limited range of motion, and sharp or dull pain radiating through the hip, lower back, or groin area. Early diagnosis and treatment through physical therapy, medications, and exercises are essential in relieving pain and preventing further injury, ultimately restoring functionality and improving mobility.",
//     image: servicesImages.hip,
//     link: "/services/hip-pain",
//     causes: [
//       {
//         title: "Arthritis",
//         description:
//           "Joint inflammation causes pain, stiffness, and swelling in the hip, reducing mobility.",
//       },
//       {
//         title: "Bursitis",
//         description:
//           "Inflammation of the bursae leads to pain when moving the hip or sitting for prolonged periods.",
//       },
//       {
//         title: "Labral Tear",
//         description:
//           "A tear in the cartilage around the hip joint can cause pain and restrict movement.",
//       },
//       {
//         title: "Tendinitis",
//         description:
//           "Inflamed tendons from overuse lead to sharp or aching pain around the hip.",
//       },
//       {
//         title: "Hip Fractures",
//         description:
//           "A fracture in the hip bone causes severe pain and requires immediate medical attention.",
//       },
//       {
//         title: "Muscle Strain",
//         description:
//           "Overuse or sudden movements can strain the muscles, leading to pain and stiffness.",
//       },
//     ],
//     management: [
//       {
//         title: "Physical Therapy",
//         description:
//           "Exercises and stretches improve mobility and strengthen hip muscles.",
//       },
//       {
//         title: "Corticosteroid Injections",
//         description:
//           "Injections reduce inflammation and provide temporary relief from hip pain.",
//       },
//       {
//         title: "Heat and Cold Therapy",
//         description:
//           "Alternating heat and cold applications can reduce pain and inflammation.",
//       },
//       {
//         title: "Assistive Devices",
//         description:
//           "Walking aids like canes or crutches can help reduce hip strain and pain.",
//       },
//       {
//         title: "Strength Training",
//         description:
//           "Building muscle strength around the hip joint can reduce pain and prevent further injury.",
//       },
//       {
//         title: "Surgical Intervention",
//         description:
//           "In severe cases, hip replacement surgery may be necessary to restore joint function.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Robert Brown",
//         specialization: "Orthopedic Surgeon",
//         degree: "M.D.",
//         experience: "12 years of experience",
//         tags: ["Hip Surgery", "Joint Replacement", "Arthritis Management"],
//         image: doctorHomeImages.doctor19,
//       },
//       {
//         name: "Dr. Emily Davis",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "14 years of experience",
//         tags: ["Hip Pain", "Physical Therapy", "Rehabilitation"],
//         image: doctorHomeImages.doctor1,
//       },
//       {
//         name: "Dr. Mark Taylor",
//         specialization: "Chiropractor",
//         degree: "D.C.",
//         experience: "13 years of experience",
//         tags: ["Hip Adjustments", "Joint Pain Relief", "Posture Correction"],
//         image: doctorHomeImages.doctor8,
//       },
//     ],
//     causeImage: servicesImages.hipPainCause,
//   },
//   {
//     id: "knee-pain",
//     title: "Knee Pain",
//     captionDescription: "Relief for knee pain and restored mobility.",
//     description:
//       "Knee pain can result from injury, overuse, or chronic conditions like arthritis. Symptoms range from sharp, localized pain to a dull ache that limits movement and activity. The knee is a complex joint, and proper diagnosis is crucial to address pain and restore functionality. Physical therapy, medications, and sometimes surgery are common treatments for knee pain, focusing on strengthening the joint, reducing inflammation, and improving mobility for long-term relief.",
//     image: servicesImages.knee,
//     link: "/services/knee-pain",
//     causes: [
//       {
//         title: "Ligament Injuries",
//         description:
//           "Tears in the knee ligaments cause pain, swelling, and instability in the joint.",
//       },
//       {
//         title: "Arthritis",
//         description:
//           "Joint inflammation leads to chronic pain and stiffness in the knee.",
//       },
//       {
//         title: "Meniscus Tear",
//         description:
//           "A torn cartilage in the knee joint can cause pain and limit mobility.",
//       },
//       {
//         title: "Tendinitis",
//         description:
//           "Inflammation in the tendons causes pain during movement or after physical activity.",
//       },
//       {
//         title: "Knee Fractures",
//         description:
//           "A break in the knee bone results in severe pain and requires immediate treatment.",
//       },
//       {
//         title: "Patellar Dislocation",
//         description:
//           "The kneecap shifts out of place, causing pain and swelling in the knee.",
//       },
//     ],
//     management: [
//       {
//         title: "Physical Therapy",
//         description:
//           "Targeted exercises strengthen the knee and improve flexibility.",
//       },
//       {
//         title: "Anti-Inflammatory Medication",
//         description: "Medications reduce swelling and alleviate pain.",
//       },
//       {
//         title: "Knee Bracing",
//         description:
//           "Braces provide support to the knee joint and reduce strain during movement.",
//       },
//       {
//         title: "Heat and Cold Therapy",
//         description:
//           "Alternating between heat and cold helps reduce inflammation and pain.",
//       },
//       {
//         title: "Stretching Exercises",
//         description:
//           "Targeted stretches improve flexibility and prevent stiffness.",
//       },
//       {
//         title: "Surgical Intervention",
//         description:
//           "In severe cases, surgery may be required to repair damaged tissues and restore knee function.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Paul Sidhu",
//         specialization: "Orthopedic Surgeon",
//         degree: "M.D.",
//         experience: "19 years of experience",
//         tags: ["Knee Surgery", "ACL Repair", "Joint Replacement"],
//         image: doctorHomeImages.doctor6,
//       },
//       {
//         name: "Dr. Laura Martinez",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "15 years of experience",
//         tags: ["Knee Pain", "Post-Surgical Rehab", "Joint Stability"],
//         image: doctorHomeImages.doctor5,
//       },
//       {
//         name: "Dr. Kevin Brown",
//         specialization: "Chiropractor",
//         degree: "D.C.",
//         experience: "17 years of experience",
//         tags: ["Knee Adjustments", "Joint Pain Relief", "Posture Correction"],
//         image: doctorHomeImages.doctor10,
//       },
//     ],
//     causeImage: servicesImages.kneePainCause,
//   },

//   {
//     id: "elbow-pain",
//     title: "Elbow Pain",
//     captionDescription: "Relieve elbow pain and restore mobility.",
//     description:
//       "Elbow pain can be caused by overuse, injury, or conditions such as tennis elbow or arthritis. This discomfort can hinder daily activities like lifting or gripping. Common symptoms include sharp pain, swelling, and stiffness. Early diagnosis and treatment, including physical therapy, medications, and strengthening exercises, can alleviate pain and improve elbow function, preventing long-term damage and restoring normal movement.",
//     image: servicesImages.elbow,
//     link: "/services/elbow-pain",
//     causes: [
//       {
//         title: "Tennis Elbow",
//         description:
//           "Overuse of the elbow leads to inflammation in the tendons, causing pain and weakness.",
//       },
//       {
//         title: "Arthritis",
//         description:
//           "Joint inflammation causes stiffness, swelling, and pain in the elbow.",
//       },
//       {
//         title: "Bursitis",
//         description:
//           "Inflammation of the bursa sac results in pain and restricted elbow movement.",
//       },
//       {
//         title: "Fractures",
//         description:
//           "Elbow fractures lead to sharp pain and require immediate medical intervention.",
//       },
//       {
//         title: "Tendonitis",
//         description:
//           "Inflamed tendons cause pain and discomfort when moving the elbow.",
//       },
//       {
//         title: "Dislocations",
//         description:
//           "The elbow joint dislocates, causing severe pain and swelling.",
//       },
//     ],
//     management: [
//       {
//         title: "Physical Therapy",
//         description:
//           "Targeted exercises help improve elbow strength and flexibility.",
//       },
//       {
//         title: "Anti-Inflammatory Medication",
//         description:
//           "Medications help reduce pain and inflammation in the elbow joint.",
//       },
//       {
//         title: "Bracing",
//         description:
//           "Braces provide support and stability to the elbow during recovery.",
//       },
//       {
//         title: "Heat and Cold Therapy",
//         description:
//           "Applying heat or cold can help alleviate pain and reduce swelling.",
//       },
//       {
//         title: "Stretching Exercises",
//         description:
//           "Stretches improve flexibility and reduce stiffness in the elbow.",
//       },
//       {
//         title: "Surgical Intervention",
//         description:
//           "In severe cases, surgery may be needed to repair damaged tendons or ligaments.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. John Davis",
//         specialization: "Orthopedic Surgeon",
//         degree: "M.D.",
//         experience: "15 years of experience",
//         tags: ["Elbow Surgery", "Tendon Repair", "Joint Replacement"],
//         image: doctorHomeImages.doctor7,
//       },
//       {
//         name: "Dr. Sarah Jones",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "12 years of experience",
//         tags: ["Elbow Pain", "Rehabilitation", "Physical Therapy"],
//         image: doctorHomeImages.doctor11,
//       },
//       {
//         name: "Dr. Lisa Carter",
//         specialization: "Chiropractor",
//         degree: "D.C.",
//         experience: "10 years of experience",
//         tags: ["Joint Adjustments", "Elbow Pain Relief", "Posture Correction"],
//         image: doctorHomeImages.doctor13,
//       },
//     ],
//     causeImage: servicesImages.elbowPainCause,
//   },
//   {
//     id: "hand-pain",
//     title: "Hand Pain",
//     captionDescription: "Relieve hand pain and regain dexterity.",
//     description:
//       "Hand pain is often caused by injury, overuse, or chronic conditions like arthritis or carpal tunnel syndrome. Symptoms include stiffness, swelling, numbness, and reduced mobility, affecting the ability to perform daily tasks. Early diagnosis and treatment are crucial to restoring hand function and relieving pain. Treatments include physical therapy, medications, and sometimes surgery, depending on the severity of the condition.",
//     image: servicesImages.hand,
//     link: "/services/hand-pain",
//     causes: [
//       {
//         title: "Arthritis",
//         description:
//           "Joint inflammation causes pain and stiffness in the hands and fingers.",
//       },
//       {
//         title: "Carpal Tunnel Syndrome",
//         description:
//           "Pressure on the median nerve leads to numbness, pain, and weakness in the hand.",
//       },
//       {
//         title: "Tendinitis",
//         description:
//           "Inflamed tendons from overuse cause pain and limited hand movement.",
//       },
//       {
//         title: "Fractures",
//         description:
//           "Broken bones in the hand result in pain and require immediate medical attention.",
//       },
//       {
//         title: "Trigger Finger",
//         description:
//           "A condition where fingers get stuck in a bent position, causing pain and stiffness.",
//       },
//       {
//         title: "Sprains",
//         description:
//           "Injuries to the ligaments in the hand lead to pain and limited motion.",
//       },
//     ],
//     management: [
//       {
//         title: "Physical Therapy",
//         description: "Exercises improve hand strength and flexibility.",
//       },
//       {
//         title: "Bracing",
//         description:
//           "Braces help stabilize the hand and reduce strain on affected areas.",
//       },
//       {
//         title: "Anti-Inflammatory Medication",
//         description: "Medications help reduce inflammation and relieve pain.",
//       },
//       {
//         title: "Heat and Cold Therapy",
//         description:
//           "Applying heat or cold packs helps reduce pain and swelling.",
//       },
//       {
//         title: "Stretching Exercises",
//         description:
//           "Stretching exercises improve range of motion and flexibility.",
//       },
//       {
//         title: "Surgical Intervention",
//         description:
//           "Surgery may be necessary in severe cases to relieve nerve pressure or repair damaged ligaments.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Emily Johnson",
//         specialization: "Orthopedic Surgeon",
//         degree: "M.D.",
//         experience: "13 years of experience",
//         tags: ["Hand Surgery", "Tendon Repair", "Joint Replacement"],
//         image: doctorHomeImages.doctor12,
//       },
//       {
//         name: "Dr. Kevin Brown",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "10 years of experience",
//         tags: ["Hand Pain", "Post-Surgical Rehab", "Rehabilitation"],
//         image: doctorHomeImages.doctor14,
//       },
//       {
//         name: "Dr. Susan Clark",
//         specialization: "Chiropractor",
//         degree: "D.C.",
//         experience: "8 years of experience",
//         tags: ["Hand Adjustments", "Joint Pain Relief", "Posture Correction"],
//         image: doctorHomeImages.doctor15,
//       },
//     ],
//     causeImage: servicesImages.handPainCause,
//   },
//   {
//     id: "foot-pain",
//     title: "Foot Pain",
//     captionDescription: "Targeted care for relieving foot pain.",
//     description:
//       "Foot pain can arise from overuse, injury, or chronic conditions like plantar fasciitis and arthritis. It affects daily activities, causing discomfort and reduced mobility. Common symptoms include swelling, sharp pain, and stiffness. Prompt diagnosis and treatment, including physical therapy, orthotics, and lifestyle modifications, can effectively relieve foot pain and prevent long-term issues.",
//     image: servicesImages.foot,
//     link: "/services/foot-pain",
//     causes: [
//       {
//         title: "Plantar Fasciitis",
//         description:
//           "Inflammation of the tissue at the bottom of the foot causing stabbing pain in the heel.",
//       },
//       {
//         title: "Stress Fractures",
//         description:
//           "Small cracks in bones due to repetitive stress, leading to pain and tenderness.",
//       },
//       {
//         title: "Bunions",
//         description:
//           "A bony bump at the base of the big toe that causes pain and swelling.",
//       },
//       {
//         title: "Arthritis",
//         description:
//           "Joint inflammation in the foot leading to stiffness and pain.",
//       },
//       {
//         title: "Achilles Tendonitis",
//         description:
//           "Inflammation of the Achilles tendon causing pain near the heel.",
//       },
//       {
//         title: "Flat Feet",
//         description: "Fallen arches result in foot pain due to poor support.",
//       },
//     ],
//     management: [
//       {
//         title: "Orthotics",
//         description:
//           "Custom-made insoles provide support and alleviate pressure on painful areas.",
//       },
//       {
//         title: "Physical Therapy",
//         description:
//           "Exercises strengthen muscles and improve foot flexibility.",
//       },
//       {
//         title: "Stretching Exercises",
//         description: "Targeted stretches reduce tension in the foot muscles.",
//       },
//       {
//         title: "Anti-Inflammatory Medication",
//         description:
//           "Medications relieve pain and reduce swelling in the affected area.",
//       },
//       {
//         title: "Bracing",
//         description:
//           "Foot braces offer stability and support to alleviate pain.",
//       },
//       {
//         title: "Surgical Intervention",
//         description:
//           "In severe cases, surgery may be required to repair damaged structures.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. John Thompson",
//         specialization: "Podiatrist",
//         degree: "D.P.M.",
//         experience: "20 years of experience",
//         tags: ["Foot Surgery", "Bunions", "Plantar Fasciitis"],
//         image: doctorHomeImages.doctor8,
//       },
//       {
//         name: "Dr. Emily Harris",
//         specialization: "Orthopedic Surgeon",
//         degree: "M.D.",
//         experience: "15 years of experience",
//         tags: ["Foot Surgery", "Fractures", "Arthritis"],
//         image: doctorHomeImages.doctor9,
//       },
//       {
//         name: "Dr. Mark Foster",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "10 years of experience",
//         tags: ["Foot Pain", "Rehabilitation", "Orthotics"],
//         image: doctorHomeImages.doctor10,
//       },
//     ],
//     causeImage: servicesImages.footPainCause,
//   },
//   {
//     id: "ankle-pain",
//     title: "Ankle Pain",
//     captionDescription: "Relief from ankle pain and improved stability.",
//     description:
//       "Ankle pain is often the result of injuries, overuse, or chronic conditions like arthritis. It can significantly affect mobility and daily activities, causing swelling, stiffness, and pain. Timely treatment with physical therapy, medication, and lifestyle changes can restore ankle function and prevent further complications. Effective management helps reduce pain and improve joint stability.",
//     image: servicesImages.ankle,
//     link: "/services/ankle-pain",
//     causes: [
//       {
//         title: "Sprained Ankle",
//         description: "Ligament injury causing pain, swelling, and instability.",
//       },
//       {
//         title: "Arthritis",
//         description:
//           "Joint inflammation in the ankle leading to stiffness and pain.",
//       },
//       {
//         title: "Achilles Tendonitis",
//         description:
//           "Inflammation of the Achilles tendon causing heel and ankle pain.",
//       },
//       {
//         title: "Fractures",
//         description:
//           "Bone fractures in the ankle leading to severe pain and immobility.",
//       },
//       {
//         title: "Bursitis",
//         description:
//           "Inflammation of the bursa sacs around the ankle joint causing pain.",
//       },
//       {
//         title: "Tendinitis",
//         description: "Inflammation of the tendons surrounding the ankle joint.",
//       },
//     ],
//     management: [
//       {
//         title: "Physical Therapy",
//         description:
//           "Rehabilitation exercises to strengthen the ankle and improve stability.",
//       },
//       {
//         title: "Anti-Inflammatory Medication",
//         description: "Medications to reduce pain and swelling in the ankle.",
//       },
//       {
//         title: "Bracing",
//         description:
//           "Ankle braces provide support and help prevent further injury.",
//       },
//       {
//         title: "Rest and Ice Therapy",
//         description:
//           "Resting the ankle and applying ice reduces swelling and alleviates pain.",
//       },
//       {
//         title: "Stretching Exercises",
//         description:
//           "Exercises to improve flexibility and reduce stiffness in the ankle.",
//       },
//       {
//         title: "Surgical Intervention",
//         description:
//           "Surgery may be required for severe injuries or chronic conditions that don't respond to conservative treatments.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Laura Thompson",
//         specialization: "Orthopedic Surgeon",
//         degree: "M.D.",
//         experience: "12 years of experience",
//         tags: ["Ankle Surgery", "Fractures", "Ligament Injuries"],
//         image: doctorHomeImages.doctor11,
//       },
//       {
//         name: "Dr. Robert Williams",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "8 years of experience",
//         tags: ["Ankle Pain", "Rehabilitation", "Injury Prevention"],
//         image: doctorHomeImages.doctor12,
//       },
//       {
//         name: "Dr. Sarah Green",
//         specialization: "Chiropractor",
//         degree: "D.C.",
//         experience: "9 years of experience",
//         tags: ["Joint Adjustments", "Posture Correction", "Pain Relief"],
//         image: doctorHomeImages.doctor13,
//       },
//     ],
//     causeImage: servicesImages.anklePainCause,
//   },
//   {
//     id: "sports-injuries",
//     title: "Sports Injuries",
//     captionDescription: "Rehabilitation for common sports injuries.",
//     description:
//       "Sports injuries occur frequently and can range from mild strains to severe ligament tears or fractures. These injuries, if not treated promptly, can lead to long-term complications and impact athletic performance. Proper care, including physical therapy, strength training, and rest, can speed up recovery and help athletes get back to their sport safely and effectively.",
//     image: servicesImages.sports,
//     link: "/services/sports-injuries",
//     causes: [
//       {
//         title: "Overuse Injuries",
//         description:
//           "Repetitive motion can lead to conditions such as stress fractures, tendonitis, or bursitis.",
//       },
//       {
//         title: "Traumatic Injuries",
//         description:
//           "Accidental falls, tackles, or direct impacts can result in sprains, fractures, or dislocations.",
//       },
//       {
//         title: "Improper Technique",
//         description:
//           "Poor form or incorrect techniques can increase the risk of injury during athletic activities.",
//       },
//       {
//         title: "Lack of Warm-Up",
//         description:
//           "Failing to stretch or warm up properly can result in muscle strains or tears.",
//       },
//       {
//         title: "Inadequate Equipment",
//         description:
//           "Using worn or unsuitable sports gear may contribute to injuries.",
//       },
//       {
//         title: "Fatigue",
//         description:
//           "Excessive fatigue from overtraining can make the body vulnerable to injury.",
//       },
//     ],
//     management: [
//       {
//         title: "Rest and Recovery",
//         description:
//           "Taking sufficient rest and avoiding the aggravation of the injured area is crucial for healing.",
//       },
//       {
//         title: "Physical Therapy",
//         description:
//           "Therapies focused on rehabilitation, flexibility, and strength are essential for recovery.",
//       },
//       {
//         title: "Strength Training",
//         description:
//           "Building muscle strength supports injury prevention and faster recovery.",
//       },
//       {
//         title: "Stretching Exercises",
//         description:
//           "Regular stretches help maintain flexibility and avoid stiffness during recovery.",
//       },
//       {
//         title: "Assistive Devices",
//         description:
//           "Braces and supports can protect the injured area and help regain movement.",
//       },
//       {
//         title: "Surgical Intervention",
//         description:
//           "Severe cases like ligament tears or fractures may require surgery to restore function.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Raj Patel",
//         specialization: "Orthopedic Surgeon",
//         degree: "M.D.",
//         experience: "18 years of experience",
//         tags: ["Sports Surgery", "Fractures", "Ligament Tears"],
//         image: doctorHomeImages.doctor14,
//       },
//       {
//         name: "Dr. Claire O'Connell",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "12 years of experience",
//         tags: ["Sports Rehabilitation", "Injury Recovery", "Exercise Therapy"],
//         image: doctorHomeImages.doctor15,
//       },
//       {
//         name: "Dr. Peter Nolan",
//         specialization: "Chiropractor",
//         degree: "D.C.",
//         experience: "10 years of experience",
//         tags: ["Spinal Adjustments", "Posture Correction", "Pain Management"],
//         image: doctorHomeImages.doctor16,
//       },
//     ],
//     causeImage: servicesImages.sportsInjuriesCause,
//   },
//   {
//     id: "post-surgical-rehabilitation",
//     title: "Post-Surgical Rehabilitation",
//     captionDescription: "Restore mobility after surgery.",
//     description:
//       "Post-surgical rehabilitation is essential for regaining mobility, strength, and function after a procedure. Through guided exercises, therapies, and education, patients can reduce pain and swelling, improve joint movement, and restore normal function. This recovery process helps prevent complications and ensures a faster return to daily activities.",
//     image: servicesImages.rehabilition,
//     link: "/services/post-surgical-rehabilitation",
//     causes: [
//       {
//         title: "Joint Replacement",
//         description:
//           "Rehabilitation helps patients regain mobility after knee or hip replacement surgeries.",
//       },
//       {
//         title: "Ligament Repair",
//         description:
//           "Following ACL or MCL repair, rehabilitation ensures strength and stability are restored.",
//       },
//       {
//         title: "Fracture Repair",
//         description:
//           "Fracture surgeries require rehabilitation to restore range of motion and strength.",
//       },
//       {
//         title: "Spinal Surgery",
//         description:
//           "Post-spinal surgery therapy reduces pain and stiffness while improving mobility.",
//       },
//       {
//         title: "Rotator Cuff Surgery",
//         description:
//           "After shoulder surgery, therapy is crucial for restoring full arm movement and strength.",
//       },
//       {
//         title: "Tendon Repair",
//         description:
//           "Tendon surgeries require careful rehabilitation to prevent stiffness and improve flexibility.",
//       },
//     ],
//     management: [
//       {
//         title: "Physical Therapy",
//         description:
//           "Therapists guide patients through exercises to strengthen muscles and restore mobility.",
//       },
//       {
//         title: "Range of Motion Exercises",
//         description:
//           "Specific movements help regain flexibility and joint function post-surgery.",
//       },
//       {
//         title: "Pain Management",
//         description:
//           "Techniques like ice therapy and medication help alleviate post-surgical pain.",
//       },
//       {
//         title: "Strength Training",
//         description:
//           "Targeted exercises rebuild muscle strength in the affected area.",
//       },
//       {
//         title: "Assistive Devices",
//         description:
//           "Devices like crutches, braces, or walkers aid in recovery and movement.",
//       },
//       {
//         title: "Occupational Therapy",
//         description:
//           "Therapists teach patients how to adapt daily tasks to their current physical abilities.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Eleanor Blake",
//         specialization: "Orthopedic Surgeon",
//         degree: "M.D.",
//         experience: "20 years of experience",
//         tags: ["Joint Replacement", "Spinal Surgery", "Post-Surgical Recovery"],
//         image: doctorHomeImages.doctor17,
//       },
//       {
//         name: "Dr. Gregory Marshall",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "15 years of experience",
//         tags: [
//           "Rehabilitation",
//           "Mobility Restoration",
//           "Post-Surgical Exercises",
//         ],
//         image: doctorHomeImages.doctor18,
//       },
//       {
//         name: "Dr. Jane Collins",
//         specialization: "Occupational Therapist",
//         degree: "O.T.",
//         experience: "12 years of experience",
//         tags: [
//           "Daily Task Adaptation",
//           "Post-Surgical Recovery",
//           "Assistive Devices",
//         ],
//         image: doctorHomeImages.doctor19,
//       },
//     ],
//     causeImage: servicesImages.postSurgicalRehabilitationCause,
//   },
//   {
//     id: "pre-surgical-rehab",
//     title: "Pre-Surgical Rehab",
//     captionDescription: "Prepare your body for surgery.",
//     description:
//       "Pre-surgical rehabilitation, also known as 'prehab,' is a vital process that helps patients strengthen their bodies and improve their overall condition before surgery. By enhancing strength, flexibility, and cardiovascular health, patients can reduce the risks associated with surgery and speed up post-operative recovery. Prehab optimizes the body’s physical condition, making the surgical procedure less stressful and the healing process faster.",
//     image: servicesImages.preRehab,
//     link: "/services/pre-surgical-rehab",
//     causes: [
//       {
//         title: "Weak Muscles",
//         description:
//           "Poor muscle strength before surgery can slow recovery and increase the risk of complications.",
//       },
//       {
//         title: "Limited Range of Motion",
//         description:
//           "Restricted movement in joints or muscles can lead to post-surgical stiffness and prolonged recovery.",
//       },
//       {
//         title: "Cardiovascular Weakness",
//         description:
//           "Low cardiovascular health makes surgery riskier and can slow post-operative recovery.",
//       },
//     ],
//     management: [
//       {
//         title: "Strength Training",
//         description:
//           "Exercises to build muscle strength help improve the body's ability to recover post-surgery.",
//       },
//       {
//         title: "Cardio Conditioning",
//         description:
//           "Aerobic exercises improve heart and lung capacity, reducing surgical risks and enhancing recovery.",
//       },
//       {
//         title: "Flexibility Exercises",
//         description:
//           "Stretching and flexibility training prepare joints and muscles for surgery, reducing stiffness.",
//       },
//       {
//         title: "Patient Education",
//         description:
//           "Prehab includes educating patients on the surgery process and the exercises needed post-operation.",
//       },
//       {
//         title: "Breathing Exercises",
//         description:
//           "Breathing techniques improve lung capacity and prepare the body for anesthesia.",
//       },
//       {
//         title: "Pain Management Planning",
//         description:
//           "Learning how to manage pain post-surgery through various techniques enhances recovery.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Sarah Thompson",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "16 years of experience",
//         tags: ["Prehab", "Surgical Preparation", "Cardio Conditioning"],
//         image: doctorHomeImages.doctor20,
//       },
//       {
//         name: "Dr. Peter Nelson",
//         specialization: "Cardiologist",
//         degree: "M.D. (Cardiology)",
//         experience: "22 years of experience",
//         tags: [
//           "Cardio Conditioning",
//           "Surgical Risk Management",
//           "Pre-Surgical Rehab",
//         ],
//         image: doctorHomeImages.doctor21,
//       },
//       {
//         name: "Dr. Emma Warren",
//         specialization: "Occupational Therapist",
//         degree: "O.T.",
//         experience: "15 years of experience",
//         tags: [
//           "Flexibility Training",
//           "Pre-Surgical Education",
//           "Pain Management",
//         ],
//         image: doctorHomeImages.doctor22,
//       },
//     ],
//     causeImage: servicesImages.preSurgicalRehabCause,
//   },
//   {
//     id: "chronic-pain",
//     title: "Chronic Pain",
//     captionDescription: "Manage long-lasting pain effectively.",
//     description:
//       "Chronic pain is a condition where pain persists for months or even years, often after an injury has healed. It can result from various conditions, such as arthritis, fibromyalgia, or nerve damage, and it significantly impacts a person’s quality of life. Effective management through a combination of therapies, lifestyle modifications, and pain relief techniques can help individuals lead fuller, more active lives.",
//     image: servicesImages.chronic,
//     link: "/services/chronic-pain",
//     causes: [
//       {
//         title: "Nerve Damage",
//         description:
//           "Injury or trauma to nerves can result in persistent, debilitating pain.",
//       },
//       {
//         title: "Arthritis",
//         description:
//           "Joint inflammation from arthritis leads to ongoing pain, stiffness, and swelling.",
//       },
//       {
//         title: "Fibromyalgia",
//         description:
//           "A condition causing widespread musculoskeletal pain, often accompanied by fatigue and mood issues.",
//       },
//     ],
//     management: [
//       {
//         title: "Physical Therapy",
//         description:
//           "Therapies focused on improving mobility and reducing pain through guided exercises.",
//       },
//       {
//         title: "Pain Management Techniques",
//         description:
//           "Strategies like heat/cold therapy, massage, and electrical stimulation provide relief.",
//       },
//       {
//         title: "Lifestyle Adjustments",
//         description:
//           "Changes in diet, exercise, and daily activities help manage and reduce chronic pain.",
//       },
//       {
//         title: "Medication",
//         description:
//           "Over-the-counter and prescription medications reduce inflammation and relieve pain.",
//       },
//       {
//         title: "Cognitive Behavioral Therapy",
//         description:
//           "Mental health counseling helps manage the emotional and psychological effects of chronic pain.",
//       },
//       {
//         title: "Acupuncture",
//         description:
//           "This alternative therapy stimulates nerves and muscles to relieve chronic pain.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Angela Cooper",
//         specialization: "Pain Specialist",
//         degree: "M.D. (Pain Management)",
//         experience: "12 years of experience",
//         tags: ["Chronic Pain Management", "Nerve Pain", "Fibromyalgia"],
//         image: doctorHomeImages.doctor23,
//       },
//       {
//         name: "Dr. Michael Johnson",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "14 years of experience",
//         tags: [
//           "Chronic Pain Relief",
//           "Physical Therapy",
//           "Pain Management Techniques",
//         ],
//         image: doctorHomeImages.doctor24,
//       },
//       {
//         name: "Dr. Rachel Stevens",
//         specialization: "Acupuncturist",
//         degree: "D.Acu.",
//         experience: "10 years of experience",
//         tags: ["Chronic Pain Relief", "Acupuncture", "Alternative Therapies"],
//         image: doctorHomeImages.doctor25,
//       },
//     ],
//     causeImage: servicesImages.chronicPainCause,
//   },
//   {
//     id: "tmj-dysfunction",
//     title: "TMJ Dysfunction",
//     captionDescription: "Effective care for jaw pain and dysfunction.",
//     description:
//       "TMJ dysfunction affects the temporomandibular joint, leading to pain, stiffness, and difficulty in moving the jaw. This condition can cause discomfort while chewing, speaking, or yawning, and may result in headaches or ear pain. Effective treatment through physical therapy, medication, and lifestyle changes can alleviate symptoms and restore normal jaw function.",
//     image: servicesImages.tmj,
//     link: "/services/tmj-dysfunction",
//     causes: [
//       {
//         title: "Jaw Misalignment",
//         description:
//           "Misalignment of the jaw joints can cause pain and difficulty in movement.",
//       },
//       {
//         title: "Bruxism",
//         description:
//           "Grinding or clenching of teeth leads to stress on the jaw and surrounding muscles.",
//       },
//       {
//         title: "Arthritis",
//         description:
//           "Inflammation in the TMJ caused by arthritis results in joint pain and stiffness.",
//       },
//     ],
//     management: [
//       {
//         title: "Jaw Exercises",
//         description:
//           "Therapeutic exercises can help strengthen jaw muscles and improve alignment.",
//       },
//       {
//         title: "Splint Therapy",
//         description:
//           "Mouthguards or splints protect the jaw from grinding and clenching during sleep.",
//       },
//       {
//         title: "Pain Management",
//         description:
//           "Medications, including anti-inflammatory drugs, reduce pain and inflammation in the jaw.",
//       },
//       {
//         title: "Heat and Cold Therapy",
//         description:
//           "Application of heat or cold helps relax jaw muscles and reduce inflammation.",
//       },
//       {
//         title: "Posture Training",
//         description:
//           "Correcting poor posture can reduce the strain on the jaw and TMJ.",
//       },
//       {
//         title: "Dietary Modifications",
//         description:
//           "Eating softer foods reduces stress on the jaw, promoting healing and reducing pain.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Laura Knight",
//         specialization: "Dentist",
//         degree: "D.D.S.",
//         experience: "20 years of experience",
//         tags: ["TMJ Treatment", "Jaw Pain", "Splint Therapy"],
//         image: doctorHomeImages.doctor26,
//       },
//       {
//         name: "Dr. Emily Rogers",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "14 years of experience",
//         tags: ["TMJ Dysfunction", "Jaw Therapy", "Physical Therapy"],
//         image: doctorHomeImages.doctor27,
//       },
//       {
//         name: "Dr. James Whitfield",
//         specialization: "Chiropractor",
//         degree: "D.C.",
//         experience: "16 years of experience",
//         tags: ["Posture Correction", "TMJ Therapy", "Pain Relief"],
//         image: doctorHomeImages.doctor28,
//       },
//     ],
//     causeImage: servicesImages.tmjDysfunctionCause,
//   },
//   {
//     id: "ergonomics",
//     title: "Ergonomics",
//     captionDescription: "Optimize your work environment for health.",
//     description:
//       "Ergonomics focuses on creating a safe and efficient workspace that minimizes strain on the body. By adjusting seating, posture, and equipment positioning, individuals can prevent workplace injuries and improve comfort. Implementing ergonomic practices reduces repetitive strain injuries, promotes better posture, and enhances overall well-being. It is vital for those in desk jobs or performing repetitive tasks.",
//     image: servicesImages.ergonomics,
//     link: "/services/ergonomics",
//     causes: [
//       {
//         title: "Poor Posture",
//         description:
//           "Sitting for long hours without proper posture can strain muscles and joints.",
//       },
//       {
//         title: "Repetitive Movements",
//         description:
//           "Frequent movements, especially in a non-ergonomic setting, lead to injuries like carpal tunnel.",
//       },
//       {
//         title: "Inadequate Workstation Setup",
//         description:
//           "Poorly positioned equipment and improper chair heights contribute to discomfort and strain.",
//       },
//     ],
//     management: [
//       {
//         title: "Workstation Adjustments",
//         description:
//           "Proper desk, chair, and screen setup can minimize strain on the body.",
//       },
//       {
//         title: "Posture Training",
//         description:
//           "Training on proper sitting, standing, and lifting techniques helps reduce strain.",
//       },
//       {
//         title: "Regular Breaks",
//         description:
//           "Taking regular breaks from repetitive tasks or sitting prevents overuse injuries.",
//       },
//       {
//         title: "Ergonomic Assessments",
//         description:
//           "Professional assessments help optimize work environments for safety and comfort.",
//       },
//       {
//         title: "Supportive Equipment",
//         description:
//           "Using ergonomic keyboards, chairs, and supports reduces injury risk.",
//       },
//       {
//         title: "Stretching and Exercises",
//         description:
//           "Stretching and strengthening exercises help prevent muscle stiffness and strain.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Michael Reynolds",
//         specialization: "Occupational Therapist",
//         degree: "O.T.",
//         experience: "15 years of experience",
//         tags: ["Ergonomics", "Workplace Injuries", "Posture Training"],
//         image: doctorHomeImages.doctor29,
//       },
//       {
//         name: "Dr. Katherine Evans",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "12 years of experience",
//         tags: ["Posture Correction", "Ergonomics", "Workplace Wellness"],
//         image: doctorHomeImages.doctor30,
//       },
//       {
//         name: "Dr. David Carter",
//         specialization: "Chiropractor",
//         degree: "D.C.",
//         experience: "14 years of experience",
//         tags: ["Spinal Health", "Posture Correction", "Ergonomics"],
//         image: doctorHomeImages.doctor31,
//       },
//     ],
//     causeImage: servicesImages.ergonomicsCause,
//   },
//   {
//     id: "vestibular-rehab",
//     title: "Vestibular Rehab",
//     captionDescription: "Regain balance and reduce dizziness.",
//     description:
//       "Vestibular rehabilitation therapy (VRT) is designed to treat issues related to balance and dizziness. It is particularly effective for individuals suffering from vertigo, inner ear disorders, and balance disorders. Through specific exercises that target balance, coordination, and gaze stability, patients can reduce dizziness, improve balance, and enhance overall stability, significantly improving their quality of life.",
//     image: servicesImages.vestibular,
//     link: "/services/vestibular-rehab",
//     causes: [
//       {
//         title: "Vertigo",
//         description:
//           "A sensation of spinning or dizziness due to issues with the inner ear.",
//       },
//       {
//         title: "Meniere’s Disease",
//         description:
//           "A disorder of the inner ear causing episodes of vertigo and hearing loss.",
//       },
//       {
//         title: "Vestibular Neuritis",
//         description:
//           "Inflammation of the vestibular nerve resulting in dizziness and imbalance.",
//       },
//     ],
//     management: [
//       {
//         title: "Balance Training",
//         description:
//           "Exercises to improve balance and reduce the risk of falls.",
//       },
//       {
//         title: "Gaze Stabilization",
//         description:
//           "Exercises to improve vision and eye movement control during head motion.",
//       },
//       {
//         title: "Habituation Exercises",
//         description:
//           "Repeated exposure to movements that trigger dizziness to reduce symptoms.",
//       },
//       {
//         title: "Physical Therapy",
//         description:
//           "Improving strength and coordination to enhance balance and mobility.",
//       },
//       {
//         title: "Canalith Repositioning",
//         description:
//           "A technique used to treat benign paroxysmal positional vertigo (BPPV).",
//       },
//       {
//         title: "Patient Education",
//         description:
//           "Teaching patients how to manage symptoms and avoid triggers.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Olivia Harris",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "10 years of experience",
//         tags: ["Vestibular Disorders", "Balance Training", "Vertigo Treatment"],
//         image: doctorHomeImages.doctor32,
//       },
//       {
//         name: "Dr. Steven Walker",
//         specialization: "Audiologist",
//         degree: "Au.D.",
//         experience: "12 years of experience",
//         tags: ["Vertigo", "Hearing Loss", "Balance Disorders"],
//         image: doctorHomeImages.doctor33,
//       },
//       {
//         name: "Dr. Laura Cooper",
//         specialization: "Neurologist",
//         degree: "M.D. (Neurology)",
//         experience: "14 years of experience",
//         tags: [
//           "Vestibular Rehab",
//           "Neurological Disorders",
//           "Balance Training",
//         ],
//         image: doctorHomeImages.doctor34,
//       },
//     ],
//     causeImage: servicesImages.vestibularRehabCause,
//   },
//   {
//     id: "incontinence",
//     title: "Incontinence",
//     captionDescription: "Effective care to manage bladder control.",
//     description:
//       "Incontinence, or loss of bladder control, affects individuals of all ages and can significantly impact quality of life. It may result from muscle weakness, neurological conditions, or injury. Specialized pelvic floor therapy, along with lifestyle changes, can help manage and even eliminate symptoms. With targeted treatments, individuals can regain control and confidence, reducing the impact of incontinence on daily life.",
//     image: servicesImages.therapyservices,
//     link: "/services/incontinence",
//     causes: [
//       {
//         title: "Weak Pelvic Muscles",
//         description:
//           "Weakness in the muscles supporting the bladder leads to leakage or loss of control.",
//       },
//       {
//         title: "Pregnancy and Childbirth",
//         description:
//           "Pregnancy and vaginal delivery can stretch or weaken the pelvic floor muscles.",
//       },
//       {
//         title: "Neurological Disorders",
//         description:
//           "Conditions like multiple sclerosis or Parkinson’s can affect bladder control.",
//       },
//     ],
//     management: [
//       {
//         title: "Pelvic Floor Exercises",
//         description:
//           "Strengthening the pelvic floor muscles through Kegel exercises helps improve bladder control.",
//       },
//       {
//         title: "Bladder Training",
//         description:
//           "A schedule for bathroom visits to gradually increase bladder capacity.",
//       },
//       {
//         title: "Medication",
//         description:
//           "Prescribed medications help relax the bladder and reduce symptoms.",
//       },
//       {
//         title: "Biofeedback",
//         description:
//           "A technique that helps patients become aware of how to strengthen pelvic muscles.",
//       },
//       {
//         title: "Dietary Changes",
//         description:
//           "Avoiding foods and beverages that irritate the bladder helps reduce symptoms.",
//       },
//       {
//         title: "Surgical Options",
//         description:
//           "In severe cases, surgery can improve bladder support and control.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Emma Roberts",
//         specialization: "Urologist",
//         degree: "M.D. (Urology)",
//         experience: "18 years of experience",
//         tags: [
//           "Bladder Control",
//           "Pelvic Floor Dysfunction",
//           "Incontinence Treatment",
//         ],
//         image: doctorHomeImages.doctor35,
//       },
//       {
//         name: "Dr. Claire Adams",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "15 years of experience",
//         tags: ["Pelvic Floor Therapy", "Incontinence", "Bladder Training"],
//         image: doctorHomeImages.doctor36,
//       },
//       {
//         name: "Dr. Jack Smith",
//         specialization: "Obstetrician-Gynecologist",
//         degree: "M.D. (Obstetrics)",
//         experience: "20 years of experience",
//         tags: [
//           "Pelvic Floor Dysfunction",
//           "Pregnancy and Postpartum Care",
//           "Bladder Control",
//         ],
//         image: doctorHomeImages.doctor37,
//       },
//     ],
//     causeImage: servicesImages.incontinenceCause,
//   },
 
//   {
//     id: "wrist-pain",
//     title: "Wrist Pain",
//     captionDescription: "Restore wrist mobility and relieve pain.",
//     description: "Wrist pain can be caused by overuse, injury, or chronic conditions like arthritis. It may present as sharp, localized pain or a dull ache that limits daily activities such as typing or lifting objects. Proper diagnosis and treatment are key to relieving wrist pain and restoring hand and wrist function. Common treatments include physical therapy, medications, and bracing to improve flexibility and reduce pain.",
//     image: servicesImages.wrist,
//     link: "/services/wrist-pain",
//     causes: [
//       {
//         title: "Carpal Tunnel Syndrome",
//         description: "Pressure on the median nerve causes pain, numbness, and tingling in the wrist and hand."
//       },
//       {
//         title: "Arthritis",
//         description: "Inflammation in the wrist joint leads to chronic pain and stiffness."
//       },
//       {
//         title: "Tendinitis",
//         description: "Inflamed tendons cause pain and limit wrist movement."
//       },
//       {
//         title: "Wrist Sprains",
//         description: "Injury to ligaments in the wrist causes pain, swelling, and limited motion."
//       },
//       {
//         title: "Fractures",
//         description: "A break in the wrist bone causes severe pain and requires immediate treatment."
//       },
//       {
//         title: "Repetitive Strain Injuries",
//         description: "Overuse of the wrist from activities like typing or sports leads to pain and inflammation."
//       }
//     ],
//     management: [
//       {
//         title: "Physical Therapy",
//         description: "Exercises improve wrist flexibility, strength, and function."
//       },
//       {
//         title: "Bracing",
//         description: "A wrist brace supports the joint and reduces strain during activities."
//       },
//       {
//         title: "Anti-Inflammatory Medications",
//         description: "Medications help reduce inflammation and relieve pain."
//       },
//       {
//         title: "Heat and Cold Therapy",
//         description: "Applying heat or cold packs can reduce swelling and alleviate pain."
//       },
//       {
//         title: "Stretching Exercises",
//         description: "Stretches help improve range of motion and prevent stiffness."
//       },
//       {
//         title: "Surgical Intervention",
//         description: "In severe cases, surgery may be necessary to relieve pressure on nerves or repair ligaments."
//       }
//     ],
//     doctors: [
//       {
//         name: "Dr. Emily Parker",
//         specialization: "Orthopedic Specialist",
//         degree: "M.D. (Orthopedics)",
//         experience: "15 years of experience",
//         tags: ["Wrist Pain", "Carpal Tunnel Syndrome", "Repetitive Strain Injuries"],
//         image: doctorHomeImages.doctor1
//       },
//       {
//         name: "Dr. Michael Wong",
//         specialization: "Physiotherapist",
//         degree: "M.Sc. (Physiotherapy)",
//         experience: "12 years of experience",
//         tags: ["Wrist Rehabilitation", "Tendinitis", "Post-Surgical Rehab"],
//         image: doctorHomeImages.doctor2
//       },
//       {
//         name: "Dr. Samantha Green",
//         specialization: "Hand Surgeon",
//         degree: "M.D. (Hand Surgery)",
//         experience: "20 years of experience",
//         tags: ["Hand and Wrist Surgery", "Fractures", "Nerve Compression"],
//         image: doctorHomeImages.doctor3
//       }
//     ],
//     causeImage: servicesImages.wristPainCause
//   },
//   {
//     id: "vestibular-rehab",
//     title: "Vestibular Rehab",
//     captionDescription: "Restore balance and reduce dizziness.",
//     description:
//       "Vestibular rehabilitation therapy is a specialized treatment designed to address issues with balance and dizziness, often caused by inner ear disorders. By using targeted exercises, patients can retrain their vestibular system to improve balance, coordination, and reduce vertigo symptoms. This therapy is effective for those suffering from conditions such as benign paroxysmal positional vertigo (BPPV), Meniere's disease, and vestibular neuritis, helping individuals regain confidence in their daily activities.",
//     image: servicesImages.vestibular,
//     link: "/services/vestibular-rehab",
//     causes: [
//       {
//         title: "Benign Paroxysmal Positional Vertigo (BPPV)",
//         description:
//           "A disorder where tiny calcium particles become dislodged in the inner ear, causing dizziness.",
//       },
//       {
//         title: "Meniere's Disease",
//         description:
//           "A condition affecting the inner ear that causes vertigo, hearing loss, and tinnitus.",
//       },
//       {
//         title: "Vestibular Neuritis",
//         description:
//           "Inflammation of the vestibular nerve leading to severe dizziness and balance problems.",
//       },
//     ],
//     management: [
//       {
//         title: "Balance Retraining",
//         description:
//           "Exercises to improve coordination and reduce the risk of falls.",
//       },
//       {
//         title: "Gaze Stabilization Exercises",
//         description:
//           "Exercises designed to improve control of eye movements and reduce dizziness.",
//       },
//       {
//         title: "Positional Maneuvers",
//         description:
//           "Techniques like the Epley maneuver can help reposition the calcium particles in the inner ear.",
//       },
//       {
//         title: "Postural Exercises",
//         description:
//           "Targeted exercises that improve postural control and body alignment.",
//       },
//       {
//         title: "Physical Therapy",
//         description:
//           "A range of exercises designed to reduce dizziness and improve overall balance.",
//       },
//       {
//         title: "Vestibular Testing",
//         description:
//           "Tests to diagnose the root cause of dizziness and create a personalized rehab plan.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Evelyn Harris",
//         specialization: "Neurologist",
//         degree: "M.D. (Neurology)",
//         experience: "20 years of experience",
//         tags: ["Vertigo", "Vestibular Disorders", "Neurological Rehab"],
//         image: doctorHomeImages.doctor47,
//       },
//       {
//         name: "Dr. Paul Fisher",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "18 years of experience",
//         tags: ["Balance Disorders", "Vestibular Rehab", "Postural Therapy"],
//         image: doctorHomeImages.doctor48,
//       },
//       {
//         name: "Dr. Amanda Fox",
//         specialization: "Audiologist",
//         degree: "Au.D. (Audiology)",
//         experience: "15 years of experience",
//         tags: ["Balance Testing", "Inner Ear Disorders", "Vertigo Management"],
//         image: doctorHomeImages.doctor49,
//       },
//     ],
//     causeImage: servicesImages.vestibularRehabCause,
//   },
  
//   {
//     id: "pelvic-pain",
//     title: "Pelvic Pain",
//     captionDescription: "Relieve chronic pelvic pain and discomfort.",
//     description:
//       "Pelvic pain affects the lower abdomen and pelvis, often caused by various conditions, including gynecological, gastrointestinal, or musculoskeletal issues. Chronic pelvic pain can significantly impact daily activities and overall quality of life. Early diagnosis and a multidisciplinary approach, involving therapy and lifestyle changes, are essential for effectively managing pelvic pain. Personalized care can help alleviate discomfort and improve function.",
//     image: servicesImages.pelvic,
//     link: "/services/pelvic-pain",
//     causes: [
//       {
//         title: "Endometriosis",
//         description:
//           "Tissue similar to the lining of the uterus grows outside it, causing pain.",
//       },
//       {
//         title: "Interstitial Cystitis",
//         description:
//           "Chronic bladder pain and pressure often associated with pelvic pain.",
//       },
//       {
//         title: "Pelvic Floor Dysfunction",
//         description:
//           "Weak or tense pelvic floor muscles contribute to chronic pelvic pain.",
//       },
//     ],
//     management: [
//       {
//         title: "Physical Therapy",
//         description:
//           "Therapy aimed at relaxing and strengthening pelvic muscles to relieve pain.",
//       },
//       {
//         title: "Pain Management",
//         description:
//           "Medications to manage chronic pain and improve quality of life.",
//       },
//       {
//         title: "Trigger Point Therapy",
//         description:
//           "Massage techniques targeting specific pain points to relieve tension.",
//       },
//       {
//         title: "Lifestyle Modifications",
//         description:
//           "Dietary changes, exercise, and stress management to reduce symptoms.",
//       },
//       {
//         title: "Biofeedback",
//         description:
//           "Therapy that helps patients gain awareness and control over pelvic muscles.",
//       },
//       {
//         title: "Surgical Intervention",
//         description:
//           "In severe cases, surgery may be needed to address underlying causes of pain.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Rachel Gomez",
//         specialization: "Gynecologist",
//         degree: "M.D. (Gynecology)",
//         experience: "14 years of experience",
//         tags: ["Pelvic Disorders", "Endometriosis", "Chronic Pelvic Pain"],
//         image: doctorHomeImages.doctor53,
//       },
//       {
//         name: "Dr. Henry Wilson",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "12 years of experience",
//         tags: ["Pelvic Floor Dysfunction", "Pelvic Pain", "Women's Health"],
//         image: doctorHomeImages.doctor54,
//       },
//       {
//         name: "Dr. Linda Smith",
//         specialization: "Urologist",
//         degree: "M.D. (Urology)",
//         experience: "16 years of experience",
//         tags: ["Bladder Disorders", "Chronic Pain", "Pelvic Pain"],
//         image: doctorHomeImages.doctor55,
//       },
//     ],
//     causeImage: servicesImages.pelvicPainCause,
//   },
//   {
//     id: "stress-fractures",
//     title: "Stress Fractures",
//     captionDescription: "Expert care for healing stress fractures.",
//     description:
//       "Stress fractures are tiny cracks in bones that result from repetitive force, often caused by overuse or high-impact sports. These fractures typically affect weight-bearing bones like the tibia, femur, or metatarsals. Without proper treatment, they can lead to further injury. Early intervention through rest, physical therapy, and gradual reintroduction of activity is key to healing stress fractures and preventing long-term complications.",
//     image: servicesImages.stressfracture,
//     link: "/services/stress-fractures",
//     causes: [
//       {
//         title: "Overuse",
//         description:
//           "Repetitive high-impact activities like running or jumping can lead to small bone fractures.",
//       },
//       {
//         title: "Weak Bones",
//         description:
//           "Low bone density, often due to osteoporosis, makes bones more prone to fractures.",
//       },
//       {
//         title: "Improper Footwear",
//         description:
//           "Wearing unsupportive shoes during physical activity can contribute to stress fractures.",
//       },
//     ],
//     management: [
//       {
//         title: "Rest",
//         description:
//           "Adequate rest from weight-bearing activities allows the bones to heal properly.",
//       },
//       {
//         title: "Physical Therapy",
//         description:
//           "Rehabilitation exercises help strengthen muscles and prevent future fractures.",
//       },
//       {
//         title: "Orthotics",
//         description:
//           "Custom insoles can provide the support needed to reduce stress on the bones.",
//       },
//       {
//         title: "Gradual Return to Activity",
//         description:
//           "Slowly increasing activity levels helps prevent re-injury and allows the bone to heal.",
//       },
//       {
//         title: "Medications",
//         description:
//           "Pain relievers and medications to enhance bone healing are often used for recovery.",
//       },
//       {
//         title: "Dietary Adjustments",
//         description:
//           "Increasing calcium and vitamin D intake can support bone strength and healing.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Samantha Clark",
//         specialization: "Orthopedic Surgeon",
//         degree: "M.D. (Orthopedics)",
//         experience: "12 years of experience",
//         tags: ["Fractures", "Bone Health", "Sports Injuries"],
//         image: doctorHomeImages.doctor56,
//       },
//       {
//         name: "Dr. Matthew Cooper",
//         specialization: "Sports Medicine Specialist",
//         degree: "M.Sc (Sports Medicine)",
//         experience: "10 years of experience",
//         tags: [
//           "Stress Fractures",
//           "Athletic Rehabilitation",
//           "Injury Prevention",
//         ],
//         image: doctorHomeImages.doctor57,
//       },
//       {
//         name: "Dr. Olivia Reed",
//         specialization: "Physiotherapist",
//         degree: "M.Sc (Physiotherapy)",
//         experience: "8 years of experience",
//         tags: ["Rehabilitation", "Strength Training", "Bone Health"],
//         image: doctorHomeImages.doctor58,
//       },
//     ],
//     causeImage: servicesImages.stressFracturesCause,
//   },
// ];

  

 




//   export const dropDownSpecialities = [
//     {
//       id: 'physiotherapy',
//       title: 'Physiotherapy',
//       link: "/specialities/physiotherapy",
//     },
//     {
//       id: "massage-therapy",
//       title: "Massage Therapy",
//       link: "/specialities/massage-therapy",
//     },
//     {
//       id: "electrical-stimulation",
//       title: "Electrical Stimulation",
//       link: "/specialities/electrical-stimulation",
//     },
//     {
//       id: "kinesio-taping",
//       title: "Kinesio Taping",
//       link: "/specialities/kinesio-taping",
//     },
//     {
//       id: "trigger-point-therapy",
//       title: "Trigger Point Therapy",
//       link: "/specialities/trigger-point-therapy",
//     },
//     {
//       id: "mckenzie-technique",
//       title: "McKenzie Technique",
//       link: "/specialities/mckenzie-technique",
//     },
//     {
//       id:"others",
//       title: "Additional Specialities",
//       link: "/specialities",
//     },
//   ]











// // MARK: SPECIALITIES
//   export const specialitiesData = [
//     {
//       id: 'physiotherapy',
//       title: 'Physiotherapy',
//       description: 'Holistic care to restore movement and function after injury or illness.',
//       spec: {
//         description: 'Physiotherapy involves the use of physical methods such as massage, heat treatment, and exercise to promote healing and well-being.',
//         image: specImages.physiotherapySpec
//       },
//       howItWorks: {
//         description: 'Physiotherapy works by assessing and diagnosing the physical problem, creating a tailored treatment plan, and using various techniques to reduce pain and improve mobility.',
//         image: specImages.physiotherapyHowItWorks
//       },
//       image: specImages.spec_physiotherapy,
//       ourTreatment: [
//         {
//           title: 'Assessment & Diagnosis',
//           description: 'Initial consultation to understand the patient’s condition and identify the underlying causes.'
//         },
//         {
//           title: 'Personalized Treatment Plan',
//           description: 'Creation of a tailored plan focusing on the patient’s specific needs and goals.'
//         },
//         {
//           title: 'Manual Therapy',
//           description: 'Hands-on techniques to mobilize joints, soft tissues, and muscles.'
//         },
//         {
//           title: 'Exercise Therapy',
//           description: 'Exercises to strengthen muscles, improve flexibility, and enhance overall physical function.'
//         },
//         {
//           title: 'Patient Education',
//           description: 'Guidance on lifestyle changes, postural corrections, and home exercises to maintain progress.'
//         }
//       ]
//     },
//     {
//       id: "massage-therapy",
//       title: "Massage Therapy",
//       captionDescription: "Relieve tension, reduce pain, and relax.",
//       description: "Massage therapy uses soft tissue manipulation to relieve muscle tension, improve circulation, and promote relaxation. This therapy is effective in treating a variety of conditions such as muscle strain, chronic pain, and stress-related tension. By enhancing blood flow and flexibility, massage therapy also helps improve overall physical well-being and accelerates recovery after injury or surgery.",
//       image: specImages.spec_massage,
//       symptoms: [
//         {
//           title: "Muscle Soreness",
//           description: "General muscle discomfort from overuse or injury."
//         },
//         {
//           title: "Stiffness",
//           description: "Limited mobility due to muscle tension or joint restriction."
//         },
//         {
//           title: "Chronic Pain",
//           description: "Ongoing discomfort in muscles and joints."
//         },
//         {
//           title: "Swelling",
//           description: "Inflammation from injury or overuse."
//         },
//         {
//           title: "Stress and Anxiety",
//           description: "Physical manifestations of mental stress affecting muscles."
//         },
//         {
//           title: "Poor Circulation",
//           description: "Decreased blood flow leading to muscle fatigue and discomfort."
//         }
//       ],
//       howItWorks: {
//         description: "Massage therapy works by applying pressure to soft tissues like muscles, tendons, and ligaments to release tension and promote healing. The therapist uses techniques such as kneading, stroking, and deep tissue pressure to stimulate blood flow and release endorphins, the body’s natural pain relievers. Improved circulation helps reduce inflammation and restore mobility. This holistic approach not only treats physical pain but also promotes relaxation and stress relief, improving mental well-being and quality of life.",
//         image: specImages.massageTherapyHowItWorks
//       },
//       relatedConditions: [
//         {
//           id: "wrist-pain",
//           title: "Wrist Pain",
//           captionDescription: "Restore wrist mobility and relieve pain.",
//           link: "/services/wrist-pain"
//         },
//         {
//           id: "back-pain",
//           title: "Back Pain",
//           captionDescription: "Effective treatment for chronic and acute back pain.",
//           link: "/services/back-pain"
//         },
//         {
//           id: "neck-pain",
//           title: "Neck Pain",
//           captionDescription: "Restore neck movement and relieve pain.",
//           link: "/services/neck-pain"
//         }
//       ]
//     },
//     {
//       id: "electrical-stimulation",
//       title: "Electrical Stimulation",
//       captionDescription: "Promote healing and relieve pain.",
//       description: "Electrical Stimulation therapy uses electrical currents to reduce pain, improve circulation, and promote tissue healing. It is commonly used to treat muscle injuries, nerve pain, and post-surgical recovery. By stimulating muscle contractions, this therapy enhances blood flow and helps with muscle re-education, making it beneficial for chronic pain management and injury recovery.",
//       image: specImages.spec_electric,
//       symptoms: [
//         {
//           title: "Muscle Weakness",
//           description: "Limited muscle strength due to injury or neurological issues."
//         },
//         {
//           title: "Chronic Pain",
//           description: "Ongoing discomfort in muscles and joints."
//         },
//         {
//           title: "Nerve Pain",
//           description: "Sharp, shooting pain caused by nerve damage or irritation."
//         },
//         {
//           title: "Swelling",
//           description: "Fluid buildup around injured tissues causing discomfort."
//         },
//         {
//           title: "Poor Circulation",
//           description: "Decreased blood flow to tissues leading to muscle fatigue."
//         },
//         {
//           title: "Post-Surgical Recovery",
//           description: "Slower muscle response and recovery after surgery."
//         }
//       ],
//       howItWorks: {
//         description: "Electrical Stimulation works by sending mild electrical pulses through the skin to stimulate muscles and nerves. These pulses mimic natural muscle contractions, increasing blood flow to the treated area, reducing inflammation, and relieving pain. This therapy is often used in combination with other treatments to accelerate healing, improve mobility, and enhance overall muscle function. Electrical Stimulation is particularly beneficial for patients recovering from surgery or dealing with chronic pain conditions such as arthritis or nerve-related issues.",
//         image: specImages.electricalStimulationHowItWorks
//       },
//       relatedConditions: [
//         {
//           id: "muscle-strain",
//           title: "Muscle Strain",
//           captionDescription: "Alleviate muscle tightness and strain.",
//           link: "/services/muscle-strain"
//         },
//         {
//           id: "nerve-pain",
//           title: "Nerve Pain",
//           captionDescription: "Effective treatments to reduce nerve-related pain.",
//           link: "/services/nerve-pain"
//         },
//         {
//           id: "post-surgery-recovery",
//           title: "Post-Surgery Recovery",
//           captionDescription: "Support healing after surgical procedures.",
//           link: "/services/post-surgery-recovery"
//         }
//       ],
//       doctors: [
//         {
//           name: "Dr. Michael Brown",
//           specialization: "Physiotherapist",
//           degree: "M.Sc (Physiotherapy)",
//           experience: "15 years of experience",
//           tags: ["Muscle Recovery", "Post-Surgical Therapy", "Chronic Pain"],
//           image: doctorHomeImages.doctor1
//         },
//         {
//           name: "Dr. Samantha Green",
//           specialization: "Physical Therapist",
//           degree: "DPT",
//           experience: "12 years of experience",
//           tags: ["Nerve Pain", "Sports Injuries", "Rehabilitation"],
//           image: doctorHomeImages.doctor2
//         },
//         {
//           name: "Dr. Emily White",
//           specialization: "Rehabilitation Specialist",
//           degree: "MPT",
//           experience: "10 years of experience",
//           tags: ["Nerve Damage", "Mobility Therapy", "Post-Surgical Care"],
//           image: doctorHomeImages.doctor3
//         }
//       ]
//     },
//     {
//       id: "kinesio-taping",
//       title: "Kinesio Taping",
//       captionDescription: "Support joints and muscles.",
//       image: specImages.spec_taping,
//       description: "Kinesio Taping is a therapeutic technique that involves applying specialized elastic tape to support and stabilize muscles and joints without restricting movement. This treatment is commonly used for sports injuries, post-surgery recovery, and conditions causing muscle pain or instability. The tape provides targeted support, reducing pain and inflammation while allowing a full range of motion.",
//       symptoms: [
//         {
//           title: "Muscle Strain",
//           description: "Injury causing pain, swelling, and limited movement."
//         },
//         {
//           title: "Joint Instability",
//           description: "Weak or unstable joints due to injury or overuse."
//         },
//         {
//           title: "Swelling",
//           description: "Inflammation in the muscles or joints causing discomfort."
//         },
//         {
//           title: "Limited Mobility",
//           description: "Restricted range of motion due to pain or injury."
//         },
//         {
//           title: "Tendonitis",
//           description: "Inflammation of tendons causing pain and limited function."
//         },
//         {
//           title: "Post-Surgery Weakness",
//           description: "Reduced muscle strength and mobility after surgery."
//         }
//       ],
//       howItWorks: {
//         description: "Kinesio Taping works by applying elastic tape to the affected areas of the body. This tape gently lifts the skin, improving circulation and reducing inflammation while providing support to muscles and joints. The elasticity of the tape allows for full movement while stabilizing the affected area. Kinesio Taping helps reduce pain, prevent further injury, and promote healing, making it ideal for athletes and individuals recovering from injuries or surgery. It is often used in combination with physical therapy to enhance recovery and improve performance.",
//         image: specImages.kinesioTapingHowItWorks
//       },
//       relatedConditions: [
//         {
//           id: "shoulder-pain",
//           title: "Shoulder Pain",
//           captionDescription: "Relieve shoulder pain and improve function.",
//           link: "/services/shoulder-pain"
//         },
//         {
//           id: "ankle-pain",
//           title: "Ankle Pain",
//           captionDescription: "Support recovery from ankle injuries.",
//           link: "/services/ankle-pain"
//         },
//         {
//           id: "knee-pain",
//           title: "Knee Pain",
//           captionDescription: "Restore knee mobility and reduce pain.",
//           link: "/services/knee-pain"
//         }
//       ],
//       doctors: [
//         {
//           name: "Dr. Paul Smith",
//           specialization: "Sports Therapist",
//           degree: "M.Sc (Sports Therapy)",
//           experience: "14 years of experience",
//           tags: ["Sports Injuries", "Knee Pain", "Ankle Sprains"],
//           image: doctorHomeImages.doctor4
//         },
//         {
//           name: "Dr. Linda Martinez",
//           specialization: "Physiotherapist",
//           degree: "MPT",
//           experience: "16 years of experience",
//           tags: ["Post-Surgical Recovery", "Shoulder Pain", "Joint Support"],
//           image: doctorHomeImages.doctor5
//         },
//         {
//           name: "Dr. James Lee",
//           specialization: "Physical Therapist",
//           degree: "DPT",
//           experience: "13 years of experience",
//           tags: ["Joint Instability", "Tendonitis", "Athletic Therapy"],
//           image: doctorHomeImages.doctor6
//         }
//       ]
//     },
//     {
//       id: "trigger-point-therapy",
//       title: "Trigger Point Therapy",
//       captionDescription: "Relieve pain from muscle knots.",
//       image: specImages.spec_trigger,
//       description: "Trigger Point Therapy is a manual treatment used to relieve tight areas within muscle tissue, often referred to as ‘knots.’ This therapy helps alleviate pain, improve muscle flexibility, and restore function. It is particularly beneficial for treating conditions like chronic muscle tension, headaches, and myofascial pain. Regular sessions can help prevent the recurrence of pain and improve overall mobility.",
//       symptoms: [
//         {
//           title: "Muscle Tension",
//           description: "Tight, painful areas in muscles causing discomfort."
//         },
//         {
//           title: "Headaches",
//           description: "Pain stemming from muscle tension in the neck or back."
//         },
//         {
//           title: "Limited Mobility",
//           description: "Restricted movement due to muscle stiffness or pain."
//         },
//         {
//           title: "Chronic Muscle Pain",
//           description: "Ongoing discomfort in specific muscles or muscle groups."
//         },
//         {
//           title: "Neck and Shoulder Pain",
//           description: "Muscle tension causing pain in the upper body."
//         },
//         {
//           title: "Back Pain",
//           description: "Pain caused by muscle knots and tension."
//         }
//       ],
//       howItWorks: {
//         description: "Trigger Point Therapy works by applying direct pressure to muscle knots or trigger points, which are hyper-irritable spots within tight muscle fibers. By releasing these trigger points, pain and tension are reduced, allowing the muscle to return to its normal, pain-free state. This therapy improves blood flow to the affected area and enhances muscle flexibility, making it a powerful treatment for chronic pain conditions and muscle tightness. Regular trigger point therapy can prevent pain flare-ups and improve overall mobility and function.",
//         image: specImages.triggerPointTherapyHowItWorks
//       },
//       relatedConditions: [
//         {
//           id: "neck-pain",
//           title: "Neck Pain",
//           captionDescription: "Relieve neck tension and improve mobility.",
//           link: "/services/neck-pain"
//         },
//         {
//           id: "back-pain",
//           title: "Back Pain",
//           captionDescription: "Effective treatment for chronic and acute back pain.",
//           link: "/services/back-pain"
//         },
//         {
//           id: "headaches",
//           title: "Headaches",
//           captionDescription: "Reduce headache pain caused by muscle tension.",
//           link: "/services/headaches"
//         }
//       ],
//       doctors: [
//         {
//           name: "Dr. Amy Rogers",
//           specialization: "Physiotherapist",
//           degree: "MPT",
//           experience: "17 years of experience",
//           tags: ["Joint Instability", "Tendonitis", "Athletic Therapy"],
//           image: doctorHomeImages.doctor6
//         },
//         {
//           name: "Dr. Amy Rogers",
//           specialization: "Physiotherapist",
//           degree: "MPT",
//           experience: "17 years of experience",
//           tags: ["Joint Instability", "Tendonitis", "Athletic Therapy"],
//           image: doctorHomeImages.doctor6
//         },
//         {
//           name: "Dr. Amy Rogers",
//           specialization: "Physiotherapist",
//           degree: "MPT",
//           experience: "17 years of experience",
//           tags: ["Joint Instability", "Tendonitis", "Athletic Therapy"],
//           image: doctorHomeImages.doctor6
//         },]
//       },





















//       {
//         id: "massage-therapy",
//         title: "Massage Therapy",
//         captionDescription: "Relieve muscle tension and stress.",
//         image: specImages.spec_massage,
//         description: "Massage therapy is a hands-on technique that helps alleviate muscle tension, improve circulation, and promote relaxation. This treatment is commonly used for managing pain, reducing stress, and aiding recovery from injuries. It’s effective for both physical and mental well-being, offering relief from muscle soreness, headaches, and stress-related conditions.",
//         symptoms: [
//           {
//             title: "Muscle Tension",
//             description: "Tight, sore muscles causing discomfort and restricted movement."
//           },
//           {
//             title: "Chronic Pain",
//             description: "Persistent muscle or joint pain requiring relief."
//           },
//           {
//             title: "Headaches",
//             description: "Muscle tension leading to tension headaches."
//           },
//           {
//             title: "Stress",
//             description: "Stress and anxiety manifesting as muscle tightness."
//           },
//           {
//             title: "Poor Circulation",
//             description: "Reduced blood flow to tissues leading to fatigue."
//           },
//           {
//             title: "Injury Recovery",
//             description: "Pain and stiffness following injury, limiting mobility."
//           }
//         ],
//         howItWorks: {
//           description: "Massage therapy works by using various manual techniques to manipulate the muscles, soft tissues, and joints. By applying pressure, stretching, and kneading, the therapist helps to improve circulation, release tension, and reduce pain. This therapy promotes relaxation, stimulates healing by boosting blood flow, and helps in removing toxins from the body. It is often used as part of a comprehensive rehabilitation plan to relieve stress, treat injuries, and improve physical performance.",
//           image: specImages.massageTherapyHowItWorks
//         },
//         relatedConditions: [
//           {
//             id: "muscle-pain",
//             title: "Muscle Pain",
//             captionDescription: "Relieve pain and improve muscle function.",
//             link: "/services/muscle-pain"
//           },
//           {
//             id: "stress-relief",
//             title: "Stress Relief",
//             captionDescription: "Effective therapies to reduce stress and tension.",
//             link: "/services/stress-relief"
//           },
//           {
//             id: "injury-recovery",
//             title: "Injury Recovery",
//             captionDescription: "Support recovery from physical injuries.",
//             link: "/services/injury-recovery"
//           }
//         ],
//         doctors: [
//           {
//             name: "Dr. Helen Jones",
//             specialization: "Massage Therapist",
//             degree: "LMT",
//             experience: "12 years of experience",
//             tags: ["Chronic Pain", "Muscle Tension", "Sports Recovery"],
//             image: doctorHomeImages.doctor7
//           },
//           {
//             name: "Dr. Robert Johnson",
//             specialization: "Physical Therapist",
//             degree: "DPT",
//             experience: "10 years of experience",
//             tags: ["Injury Recovery", "Stress Management", "Joint Pain"],
//             image: doctorHomeImages.doctor8
//           },
//           {
//             name: "Dr. Emily Davis",
//             specialization: "Rehabilitation Specialist",
//             degree: "MPT",
//             experience: "14 years of experience",
//             tags: ["Massage Therapy", "Chronic Pain", "Rehabilitation"],
//             image: doctorHomeImages.doctor9
//           }
//         ]
//       },






//       {
//         id: "dry-needling",
//         title: "Dry Needling",
//         captionDescription: "Relieve muscle pain and tightness.",
//         image: specImages.spec_dryNeedle,
//         description: "Dry needling is a therapeutic technique that involves inserting thin needles into trigger points or tight muscle areas to alleviate pain and restore muscle function. It is commonly used to treat conditions such as muscle tension, joint pain, and chronic muscle stiffness. This method promotes healing by reducing muscle tightness, improving range of motion, and reducing pain in affected areas.",
//         symptoms: [
//           {
//             title: "Muscle Tightness",
//             description: "Stiff, tight muscles causing discomfort."
//           },
//           {
//             title: "Trigger Points",
//             description: "Sensitive areas in muscles causing pain and tension."
//           },
//           {
//             title: "Chronic Pain",
//             description: "Persistent pain caused by muscle tightness or injuries."
//           },
//           {
//             title: "Limited Mobility",
//             description: "Difficulty moving due to muscle pain or tightness."
//           },
//           {
//             title: "Nerve Pain",
//             description: "Pain caused by nerve compression or muscle tension."
//           },
//           {
//             title: "Sports Injuries",
//             description: "Muscle damage or strain from athletic activities."
//           }
//         ],
//         howItWorks: {
//           description: "Dry needling works by inserting thin needles directly into trigger points or tight muscles. The insertion stimulates blood flow to the area, releases tight bands of muscle, and helps to alleviate pain. This therapy helps restore muscle function, increase flexibility, and reduce inflammation. Dry needling is highly effective in managing both acute and chronic muscle pain, and it is often used in combination with other therapies to improve physical performance and support recovery from injuries.",
//           image: specImages.dryNeedlingHowItWorks
//         },
//         relatedConditions: [
//           {
//             id: "muscle-tension",
//             title: "Muscle Tension",
//             captionDescription: "Relieve tension in tight muscles.",
//             link: "/services/muscle-tension"
//           },
//           {
//             id: "joint-pain",
//             title: "Joint Pain",
//             captionDescription: "Improve joint function and reduce pain.",
//             link: "/services/joint-pain"
//           },
//           {
//             id: "nerve-pain",
//             title: "Nerve Pain",
//             captionDescription: "Alleviate nerve-related pain.",
//             link: "/services/nerve-pain"
//           }
//         ],
//         doctors: [
//           {
//             name: "Dr. Michael Brown",
//             specialization: "Physiotherapist",
//             degree: "MPT",
//             experience: "18 years of experience",
//             tags: ["Dry Needling", "Sports Injuries", "Chronic Pain"],
//             image: doctorHomeImages.doctor10
//           },
//           {
//             name: "Dr. Sarah Lewis",
//             specialization: "Physical Therapist",
//             degree: "DPT",
//             experience: "13 years of experience",
//             tags: ["Muscle Pain", "Trigger Point Therapy", "Sports Recovery"],
//             image: doctorHomeImages.doctor11
//           },
//           {
//             name: "Dr. Paul Green",
//             specialization: "Rehabilitation Specialist",
//             degree: "M.Sc (Physiotherapy)",
//             experience: "15 years of experience",
//             tags: ["Chronic Pain", "Muscle Recovery", "Dry Needling"],
//             image: doctorHomeImages.doctor12
//           }
//         ]
//       },
  
      
      

//       {
//         id: "mckenzie-technique",
//         title: "McKenzie Technique",
//         captionDescription: "Effective for spinal pain and posture correction.",
//         image: specImages.spec_mckinze,
//         description: "The McKenzie Technique focuses on assessment and treatment of musculoskeletal pain, particularly in the spine. It aims to relieve pain by restoring the normal function of joints and muscles through specific exercises. This method helps prevent future recurrences of back or neck pain by teaching patients how to maintain proper posture and body mechanics. Ideal for spinal conditions, it enhances mobility and reduces discomfort over time.",
       
//         link: "/services/mckenzie-technique",
//         symptoms: [
//           { title: "Spinal Pain", description: "Pain originating in the spine, particularly in the lower back or neck." },
//           { title: "Posture Issues", description: "Poor posture contributing to musculoskeletal pain." },
//           { title: "Sciatica", description: "Radiating pain along the sciatic nerve, often due to nerve compression." },
//           { title: "Herniated Disc", description: "A bulging disc causing pressure on spinal nerves and resulting in pain." },
//           { title: "Reduced Flexibility", description: "Limited mobility due to joint or muscle stiffness." },
//           { title: "Chronic Back Pain", description: "Ongoing pain in the lower back that interferes with daily activities." }
//         ],
//         howItWorks: {
//           description: "The McKenzie Technique begins with a thorough assessment to identify pain triggers and patterns. Treatment involves specific exercises designed to extend the spine and relieve pressure on affected areas. Over time, patients are taught self-care techniques to manage and prevent pain. The technique focuses on realigning the spine, improving posture, and strengthening the muscles that support the back and neck, ensuring long-term relief.",
//           image: specImages.mckenzieHowItWorks
//         },
//         relatedConditions: [
//           { id: "spinal-stenosis", title: "Spinal Stenosis", link: "/services/spinal-stenosis" },
//           { id: "herniated-disc", title: "Herniated Disc", link: "/services/herniated-disc" },
//           { id: "chronic-back-pain", title: "Chronic Back Pain", link: "/services/chronic-back-pain" }
//         ],
//         doctors: [
//           { name: "Dr. Andrew Lee", specialization: "Chiropractor", degree: "DC", experience: "15 years", tags: ["Back Pain", "Neck Pain", "Posture Correction"], image: doctorHomeImages.doctor1 },
//           { name: "Dr. Emily Carter", specialization: "Physiotherapist", degree: "MPT", experience: "12 years", tags: ["Spinal Conditions", "McKenzie Technique"], image: doctorHomeImages.doctor2 },
//           { name: "Dr. Jason Evans", specialization: "Orthopedic Specialist", degree: "MD", experience: "20 years", tags: ["Herniated Discs", "Chronic Pain", "Spinal Care"], image: doctorHomeImages.doctor3 }
//         ]
//       },
      
//       {
//         id: "laser-therapy",
//         title: "Laser Therapy",
//         captionDescription: "Advanced treatment for pain relief and healing.",
//         image: specImages.spec_laser,
//         description: "Laser Therapy uses focused light to reduce pain and inflammation, accelerate tissue repair, and enhance cell function. It is an effective treatment for soft tissue injuries, chronic conditions, and post-surgical recovery. Laser therapy is non-invasive and painless, promoting faster healing by increasing blood flow and stimulating the body's natural healing processes.",
        
//         link: "/services/laser-therapy",
//         symptoms: [
//           { title: "Inflammation", description: "Swelling and redness in muscles or joints." },
//           { title: "Soft Tissue Injury", description: "Damage to muscles, ligaments, or tendons from strain or trauma." },
//           { title: "Chronic Pain", description: "Persistent pain lasting over three months." },
//           { title: "Post-Surgical Pain", description: "Discomfort and pain following surgery." },
//           { title: "Arthritis", description: "Joint inflammation causing pain and stiffness." },
//           { title: "Tendinitis", description: "Inflamed tendons causing pain and limited movement." }
//         ],
//         howItWorks: {
//           description: "Laser therapy uses specific wavelengths of light to penetrate deep into tissues. This light energy promotes cellular regeneration, increases circulation, and reduces inflammation. Treatments are painless and typically last 5-10 minutes per session. Laser therapy accelerates healing by enhancing cellular metabolism and reducing oxidative stress, making it ideal for injuries, chronic conditions, and recovery after surgery.",
//           image: specImages.laserHowItWorks
//         },
//         relatedConditions: [
//           { id: "tendinitis", title: "Tendinitis", link: "/services/tendinitis" },
//           { id: "arthritis", title: "Arthritis", link: "/services/arthritis" },
//           { id: "chronic-pain", title: "Chronic Pain", link: "/services/chronic-pain" }
//         ],
//         doctors: [
//           { name: "Dr. Alice Reed", specialization: "Laser Therapy Specialist", degree: "PhD", experience: "10 years", tags: ["Laser Therapy", "Chronic Pain", "Soft Tissue Injury"], image: doctorHomeImages.doctor4 },
//           { name: "Dr. Brian Lewis", specialization: "Sports Medicine Specialist", degree: "MD", experience: "14 years", tags: ["Sports Injuries", "Tendinitis"], image: doctorHomeImages.doctor5 },
//           { name: "Dr. Carol Kim", specialization: "Physiotherapist", degree: "MPT", experience: "12 years", tags: ["Post-Surgical Care", "Inflammation"], image: doctorHomeImages.doctor6 }
//         ]
//       },
      
//       {
//         id: "orthotics",
//         title: "Orthotics",
//         captionDescription: "Custom foot supports for alignment and pain relief.",
//         description: "Orthotics are custom-made shoe inserts designed to support foot alignment, reduce pain, and improve balance. They are commonly used for conditions such as plantar fasciitis, flat feet, and heel spurs. By distributing weight evenly and correcting foot posture, orthotics provide relief from foot, ankle, and knee pain while preventing future injuries.",
//         image: specImages.spec_orthotics,
//         link: "/services/orthotics",
//         symptoms: [
//           { title: "Flat Feet", description: "Collapsing arches causing pain and poor posture." },
//           { title: "Plantar Fasciitis", description: "Inflammation of the tissue along the bottom of the foot." },
//           { title: "Heel Spurs", description: "Bony growths on the heel causing sharp pain." },
//           { title: "Ankle Instability", description: "Weak or unstable ankles leading to frequent twisting or pain." },
//           { title: "Knee Pain", description: "Improper foot alignment causing strain on the knees." },
//           { title: "Lower Back Pain", description: "Foot misalignment affecting overall posture and leading to back pain." }
//         ],
//         howItWorks: {
//           description: "Orthotics work by correcting the alignment of the feet and distributing weight evenly across the foot. Custom-made from a mold of the patient’s foot, they are placed inside the shoe to provide support and relieve pressure on specific areas. By improving foot posture, orthotics can reduce strain on the knees, hips, and lower back, leading to overall pain relief and better mobility.",
//           image: specImages.orthoticsHowItWorks
//         },
//         relatedConditions: [
//           { id: "plantar-fasciitis", title: "Plantar Fasciitis", link: "/services/plantar-fasciitis" },
//           { id: "knee-pain", title: "Knee Pain", link: "/services/knee-pain" },
//           { id: "lower-back-pain", title: "Lower Back Pain", link: "/services/lower-back-pain" }
//         ],
//         doctors: [
//           { name: "Dr. Michael Harris", specialization: "Podiatrist", degree: "DPM", experience: "20 years", tags: ["Foot Pain", "Orthotics", "Flat Feet"], image: doctorHomeImages.doctor7 },
//           { name: "Dr. Jennifer Lee", specialization: "Physiotherapist", degree: "MPT", experience: "15 years", tags: ["Foot Alignment", "Lower Back Pain"], image: doctorHomeImages.doctor8 },
//           { name: "Dr. Robert White", specialization: "Orthopedic Surgeon", degree: "MD", experience: "18 years", tags: ["Knee Pain", "Heel Spurs", "Orthotics"], image: doctorHomeImages.doctor9 }
//         ]
//       },
//       {
//         id: "therapeutic-exercise",
//         title: "Therapeutic Exercise",
//         captionDescription: "Strengthening muscles and restoring function.",
//         description: "Therapeutic exercise is a key part of rehabilitation, designed to strengthen muscles, restore movement, and enhance flexibility. These exercises are customized for each individual, targeting specific areas of weakness or injury. They help improve physical function, manage pain, and prevent further injury. Regular guided exercise accelerates recovery from surgery or injury and promotes long-term wellness.",
//         image: specImages.spec_therapy,
//         link: "/services/therapeutic-exercise",
//         symptoms: [
//           { title: "Muscle Weakness", description: "Weak muscles leading to limited strength and movement." },
//           { title: "Joint Stiffness", description: "Reduced range of motion due to tight or stiff joints." },
//           { title: "Post-Surgical Recovery", description: "Limited mobility and strength following surgery." },
//           { title: "Chronic Pain", description: "Ongoing discomfort that interferes with daily activities." },
//           { title: "Balance Issues", description: "Poor balance and stability, increasing the risk of falls." },
//           { title: "Limited Flexibility", description: "Inability to stretch or bend certain joints fully." }
//         ],
//         howItWorks: {
//           description: "Therapeutic exercises focus on specific goals like strengthening weak muscles, improving joint mobility, and reducing pain. Under the guidance of a physical therapist, patients engage in a series of movements designed to target affected areas. Over time, this helps rebuild muscle strength, restore flexibility, and improve overall coordination. These exercises can be performed both in-clinic and at home as part of a long-term rehabilitation plan, promoting faster recovery and reducing the likelihood of re-injury.",
//           image: specImages.therapeuticExerciseHowItWorks
//         },
//         relatedConditions: [
//           { id: "chronic-pain", title: "Chronic Pain", link: "/services/chronic-pain" },
//           { id: "joint-stiffness", title: "Joint Stiffness", link: "/services/joint-stiffness" },
//           { id: "muscle-weakness", title: "Muscle Weakness", link: "/services/muscle-weakness" }
//         ],
//         doctors: [
//           { name: "Dr. Amanda Green", specialization: "Physiotherapist", degree: "DPT", experience: "14 years", tags: ["Rehabilitation", "Chronic Pain", "Therapeutic Exercise"], image: doctorHomeImages.doctor10 },
//           { name: "Dr. John Smith", specialization: "Sports Medicine", degree: "MD", experience: "16 years", tags: ["Post-Surgical Care", "Muscle Weakness", "Rehabilitation"], image: doctorHomeImages.doctor11 },
//           { name: "Dr. Emily Thompson", specialization: "Orthopedic Surgeon", degree: "MD", experience: "18 years", tags: ["Post-Surgical Care", "Therapeutic Exercise"], image: doctorHomeImages.doctor12 }
//         ]
//       },
//       {
//         id: "cupping",
//         title: "Cupping",
//         captionDescription: "Ancient therapy for pain relief and circulation.",
//         description: "Cupping therapy is a traditional practice that uses suction to promote circulation and relieve muscle tension. Small cups are placed on the skin, creating a vacuum that draws the skin and underlying tissues into the cup. This stimulates blood flow and helps reduce pain, inflammation, and muscle tightness. Cupping is often used in conjunction with massage or acupuncture for comprehensive pain management.",
//         image: specImages.spec_therapy,
//         link: "/services/cupping",
//         symptoms: [
//           { title: "Muscle Tightness", description: "Tension in muscles causing discomfort and limited movement." },
//           { title: "Poor Circulation", description: "Inadequate blood flow to specific areas, causing pain or weakness." },
//           { title: "Chronic Pain", description: "Persistent pain that does not subside with traditional treatments." },
//           { title: "Inflammation", description: "Swollen muscles or joints due to injury or overuse." },
//           { title: "Back Pain", description: "Discomfort in the lower or upper back." },
//           { title: "Neck Pain", description: "Tightness or discomfort in the neck area." }
//         ],
//         howItWorks: {
//           description: "Cupping therapy works by creating a vacuum effect on the skin's surface, which pulls blood into the targeted area. The increased circulation helps reduce inflammation, relieve pain, and promote healing. Cupping is often used in combination with other therapies, like massage or acupuncture, to provide a comprehensive approach to pain management. Treatments are safe, non-invasive, and can be tailored to suit the needs of each patient, depending on the severity of their symptoms.",
//           image: specImages.cuppingHowItWorks
//         },
//         relatedConditions: [
//           { id: "chronic-pain", title: "Chronic Pain", link: "/services/chronic-pain" },
//           { id: "back-pain", title: "Back Pain", link: "/services/back-pain" },
//           { id: "muscle-tightness", title: "Muscle Tightness", link: "/services/muscle-tightness" }
//         ],
//         doctors: [
//           { name: "Dr. Olivia Perez", specialization: "Acupuncturist", degree: "DACM", experience: "10 years", tags: ["Cupping", "Chronic Pain", "Acupuncture"], image: doctorHomeImages.doctor13 },
//           { name: "Dr. Lucas Wong", specialization: "Physiotherapist", degree: "DPT", experience: "12 years", tags: ["Cupping", "Muscle Pain", "Rehabilitation"], image: doctorHomeImages.doctor14 },
//           { name: "Dr. Sophia Lee", specialization: "Sports Medicine", degree: "MD", experience: "15 years", tags: ["Sports Injuries", "Chronic Pain", "Cupping"], image: doctorHomeImages.doctor15 }
//         ]
//       },
//       {
//         id: "vestibular-therapy",
//         title: "Vestibular Therapy",
//         captionDescription: "Regain balance and stability.",
//         description: "Vestibular therapy focuses on improving balance and reducing dizziness by addressing issues in the inner ear that affect equilibrium. This therapy is particularly helpful for individuals with vertigo, dizziness, or balance disorders. Through exercises that challenge the vestibular system, patients can regain their balance, reduce symptoms, and improve overall quality of life.",
//         image: specImages.spec_physiotherapy,
//         link: "/services/vestibular-therapy",
//         symptoms: [
//           { title: "Dizziness", description: "Feeling lightheaded or faint due to vestibular dysfunction." },
//           { title: "Vertigo", description: "A sensation of spinning or loss of balance caused by inner ear issues." },
//           { title: "Unsteadiness", description: "Difficulty maintaining balance during walking or standing." },
//           { title: "Blurred Vision", description: "Trouble focusing vision during movement." },
//           { title: "Nausea", description: "Feeling sick to the stomach, often linked with dizziness." },
//           { title: "Poor Coordination", description: "Challenges in walking or controlling body movements." }
//         ],
//         howItWorks: {
//           description: "Vestibular therapy helps retrain the brain to better process signals from the inner ear. A therapist designs exercises that improve gaze stability, balance, and coordination. These exercises challenge the brain to adapt to movements, reducing dizziness and restoring balance. Patients learn head, body, and eye movements to overcome symptoms. Vestibular therapy not only addresses current symptoms but also helps prevent future occurrences of imbalance or dizziness, improving daily activities and confidence.",
//           image: specImages.vestibularTherapyHowItWorks
//         },
//         relatedConditions: [
//           { id: "vertigo", title: "Vertigo", link: "/services/vertigo" },
//           { id: "dizziness", title: "Dizziness", link: "/services/dizziness" },
//           { id: "balance-disorders", title: "Balance Disorders", link: "/services/balance-disorders" }
//         ],
//         doctors: [
//           { name: "Dr. Jessica Wright", specialization: "Physiotherapist", degree: "MPTh (Neuro)", experience: "12 years of experience", tags: ["Balance Issues", "Dizziness", "Vertigo"], image: doctorHomeImages.doctor7 },
//           { name: "Dr. Mark Henderson", specialization: "Vestibular Specialist", degree: "PhD (Neuroscience)", experience: "15 years of experience", tags: ["Balance Disorders", "Vertigo", "Gait Disorders"], image: doctorHomeImages.doctor8 },
//           { name: "Dr. Emily Watson", specialization: "Physiotherapist", degree: "M.Sc (Physiotherapy)", experience: "9 years of experience", tags: ["Vestibular Rehab", "Neurological Rehab"], image: doctorHomeImages.doctor9 }
//         ]
//       },

//       {
//   id: "chiropractic-therapy",
//   title: "Chiropractic Therapy",
//   captionDescription: "Realign the spine and relieve pain.",
//   description: "Chiropractic therapy focuses on diagnosing and treating musculoskeletal disorders, especially those related to the spine. Chiropractors use hands-on spinal adjustments and other manual techniques to improve joint mobility and reduce pain. It’s effective for back pain, neck pain, headaches, and more. Chiropractic care helps restore alignment, improve function, and support the body's natural healing ability.",
//   image: specImages.spec_laser,
//   link: "/services/chiropractic-therapy",
//   symptoms: [
//     { title: "Back Pain", description: "Chronic or acute pain in the lower or upper back due to spinal misalignment." },
//     { title: "Neck Pain", description: "Pain and stiffness in the neck caused by poor posture or injury." },
//     { title: "Headaches", description: "Tension headaches or migraines triggered by spinal issues." },
//     { title: "Sciatica", description: "Sharp pain radiating from the lower back down the leg, caused by nerve compression." },
//     { title: "Joint Stiffness", description: "Limited range of motion in the spine or joints due to misalignment." },
//     { title: "Muscle Tension", description: "Tight muscles often caused by improper spinal alignment." }
//   ],
//   howItWorks: {
//     description: "Chiropractic therapy works by adjusting the spine to correct misalignments that may cause pain and dysfunction. A chiropractor will use manual adjustments or specialized tools to manipulate the spine and other joints, restoring alignment and promoting mobility. The therapy reduces nerve irritation, alleviates muscle tension, and supports the body’s ability to heal naturally. Chiropractic therapy also emphasizes holistic care, integrating exercises, nutrition, and lifestyle advice to maintain long-term spinal health and prevent future issues.",
//     image: specImages.chiropracticTherapyHowItWorks
//   },
//   relatedConditions: [
//     { id: "back-pain", title: "Back Pain", link: "/services/back-pain" },
//     { id: "neck-pain", title: "Neck Pain", link: "/services/neck-pain" },
//     { id: "sciatica", title: "Sciatica", link: "/services/sciatica" }
//   ],
//   doctors: [
//     { name: "Dr. Laura Hill", specialization: "Chiropractor", degree: "DC (Doctor of Chiropractic)", experience: "10 years of experience", tags: ["Spinal Adjustments", "Back Pain", "Sciatica"], image: doctorHomeImages.doctor10 },
//     { name: "Dr. Chris Morgan", specialization: "Chiropractor", degree: "DC (Doctor of Chiropractic)", experience: "8 years of experience", tags: ["Neck Pain", "Posture Correction", "Joint Pain"], image: doctorHomeImages.doctor11 },
//     { name: "Dr. Olivia Moore", specialization: "Chiropractor", degree: "DC (Doctor of Chiropractic)", experience: "14 years of experience", tags: ["Headaches", "Lower Back Pain", "Sports Injuries"], image: doctorHomeImages.doctor12 }
//   ]
// },
// {
//   id: "compression-hosiery",
//   title: "Compression Hosiery/Stockings",
//   captionDescription: "Support circulation and reduce swelling.",
//   description: "Compression hosiery or stockings are designed to improve blood flow, reduce swelling, and prevent conditions such as varicose veins or deep vein thrombosis. By applying gentle pressure to the legs, they help blood circulate more efficiently. Often prescribed for people with circulatory problems, these stockings can prevent blood clots and reduce the discomfort caused by poor circulation.",
//   image: specImages.spec_dryNeedle,
//   link: "/services/compression-hosiery",
//   symptoms: [
//     { title: "Swelling", description: "Excess fluid buildup in the legs causing discomfort." },
//     { title: "Varicose Veins", description: "Swollen, twisted veins visible under the skin, causing pain and fatigue." },
//     { title: "Leg Fatigue", description: "Feeling of tiredness or heaviness in the legs after standing or sitting for long periods." },
//     { title: "Deep Vein Thrombosis", description: "A blood clot in the deep veins, causing leg pain and swelling." },
//     { title: "Lymphedema", description: "Swelling in the arms or legs caused by lymphatic system blockage." },
//     { title: "Chronic Venous Insufficiency", description: "Poor blood flow from the legs back to the heart, causing skin changes and ulcers." }
//   ],
//   howItWorks: {
//     description: "Compression stockings work by applying graduated pressure to the legs, helping veins and muscles move blood efficiently back to the heart. They reduce the diameter of distended veins, increase blood flow velocity, and improve valve function. This decreases the risk of blood pooling and clot formation. Compression hosiery is available in varying degrees of pressure and can be prescribed based on the severity of the condition. They are used both for preventative care and as a part of treatment for circulatory disorders.",
//     image: specImages.compressionHosieryHowItWorks
//   },
//   relatedConditions: [
//     { id: "varicose-veins", title: "Varicose Veins", link: "/services/varicose-veins" },
//     { id: "deep-vein-thrombosis", title: "Deep Vein Thrombosis", link: "/services/deep-vein-thrombosis" },
//     { id: "lymphedema", title: "Lymphedema", link: "/services/lymphedema" }
//   ],
//   doctors: [
//     { name: "Dr. Amy Stone", specialization: "Vascular Specialist", degree: "M.D. (Vascular Surgery)", experience: "14 years of experience", tags: ["Varicose Veins", "Lymphedema", "Chronic Venous Insufficiency"], image: doctorHomeImages.doctor15 },
//     { name: "Dr. Daniel Taylor", specialization: "Physiotherapist", degree: "M.Sc (Physiotherapy)", experience: "10 years of experience", tags: ["Compression Therapy", "Swelling Reduction", "Lymphedema"], image: doctorHomeImages.doctor16 },
//     { name: "Dr. Rachel Lewis", specialization: "Physiotherapist", degree: "DPT (Doctor of Physical Therapy)", experience: "7 years of experience", tags: ["Circulation Issues", "Chronic Pain", "Compression Stockings"], image: doctorHomeImages.doctor17 }
//   ]
// },
// {
//   id: "ultrasound-therapy",
//   title: "Ultrasound Therapy",
//   captionDescription: "Accelerate healing with sound waves.",
//   description: "Ultrasound therapy is a non-invasive treatment that uses high-frequency sound waves to promote tissue healing and reduce pain. It's commonly used to treat musculoskeletal injuries, inflammation, and soft tissue conditions. The sound waves penetrate deep into tissues, improving blood flow, reducing swelling, and stimulating the body's natural healing processes. It’s ideal for patients looking to speed up recovery without surgery.",
//   image: specImages.spec_massage,
//   link: "/services/ultrasound-therapy",
//   symptoms: [
//     { title: "Muscle Strains", description: "Torn or overstretched muscles causing pain and swelling." },
//     { title: "Tendonitis", description: "Inflammation of the tendons causing pain and limited movement." },
//     { title: "Ligament Injuries", description: "Torn or damaged ligaments affecting joint stability." },
//     { title: "Scar Tissue", description: "Thickened tissue that limits movement and causes pain." },
//     { title: "Bursitis", description: "Inflammation of the bursae causing pain in joints." },
//     { title: "Sprains", description: "Injury to ligaments causing pain and swelling in the joints." }
//   ],
//   howItWorks: {
//     description: "Ultrasound therapy works by sending high-frequency sound waves into the affected tissues. The sound waves generate heat and micro-vibrations within the tissues, which increase blood circulation, reduce inflammation, and promote cell repair. This improves tissue flexibility, reduces stiffness, and helps break down scar tissue. Ultrasound is particularly effective for treating soft tissue injuries, reducing pain, and speeding up the recovery process. It is safe, non-invasive, and can be used as part of a comprehensive rehabilitation plan.",
//     image: specImages.ultrasoundTherapyHowItWorks
//   },
//   relatedConditions: [
//     { id: "muscle-strains", title: "Muscle Strains", link: "/services/muscle-strains" },
//     { id: "tendonitis", title: "Tendonitis", link: "/services/tendonitis" },
//     { id: "ligament-injuries", title: "Ligament Injuries", link: "/services/ligament-injuries" }
//   ],
//   doctors: [
//     { name: "Dr. Emily Parker", specialization: "Physiotherapist", degree: "MPT (Musculoskeletal)", experience: "11 years of experience", tags: ["Ultrasound Therapy", "Soft Tissue Injuries", "Muscle Strains"], image: doctorHomeImages.doctor18 },
//     { name: "Dr. Michael Smith", specialization: "Orthopedic Specialist", degree: "M.D. (Orthopedics)", experience: "17 years of experience", tags: ["Tendonitis", "Ligament Injuries", "Muscle Tears"], image: doctorHomeImages.doctor19 },
//     { name: "Dr. Sarah Williams", specialization: "Physiotherapist", degree: "DPT (Doctor of Physical Therapy)", experience: "8 years of experience", tags: ["Soft Tissue Injuries", "Chronic Pain", "Ultrasound Therapy"], image: doctorHomeImages.doctor20 }
//   ]
// },
// {
//   id: "manual-therapy",
//   title: "Manual Therapy",
//   captionDescription: "Hands-on techniques for pain relief.",
//   description: "Manual therapy is a hands-on treatment method used to alleviate pain and improve mobility. Therapists use various techniques such as joint manipulation, soft tissue mobilization, and stretching to treat musculoskeletal conditions. This therapy is particularly beneficial for individuals suffering from chronic pain, joint stiffness, or muscle tension. It aims to restore normal movement patterns, improve function, and promote healing without the need for surgery or medication.",
//   image: specImages.spec_orthotics,
//   link: "/services/manual-therapy",
//   symptoms: [
//     { title: "Joint Stiffness", description: "Restricted joint movement due to injury or chronic conditions." },
//     { title: "Muscle Tension", description: "Tight muscles causing discomfort and limited mobility." },
//     { title: "Back Pain", description: "Chronic or acute pain in the lower or upper back." },
//     { title: "Neck Pain", description: "Pain and stiffness in the cervical spine limiting head movement." },
//     { title: "Shoulder Pain", description: "Discomfort or reduced range of motion in the shoulder joint." },
//     { title: "Sports Injuries", description: "Injuries caused by physical activities leading to pain and immobility." }
//   ],
//   howItWorks: {
//     description: "Manual therapy works by applying targeted pressure and manipulation techniques to joints, muscles, and soft tissues. Therapists use their hands to mobilize joints, massage muscles, and stretch tissues, which helps reduce pain, increase mobility, and improve function. This therapy is effective for treating musculoskeletal conditions like back pain, joint stiffness, and sports injuries. By restoring proper movement, manual therapy supports the body's natural healing process and reduces reliance on medications.",
//     image: specImages.manualTherapyHowItWorks
//   },
//   relatedConditions: [
//     { id: "back-pain", title: "Back Pain", link: "/services/back-pain" },
//     { id: "neck-pain", title: "Neck Pain", link: "/services/neck-pain" },
//     { id: "sports-injuries", title: "Sports Injuries", link: "/services/sports-injuries" }
//   ],
//   doctors: [
//     { name: "Dr. Amanda Lewis", specialization: "Physiotherapist", degree: "MPT (Musculoskeletal)", experience: "12 years of experience", tags: ["Manual Therapy", "Joint Stiffness", "Muscle Tension"], image: doctorHomeImages.doctor21 },
//     { name: "Dr. Michael Carter", specialization: "Orthopedic Specialist", degree: "M.D. (Orthopedics)", experience: "15 years of experience", tags: ["Back Pain", "Shoulder Pain", "Joint Manipulation"], image: doctorHomeImages.doctor22 },
//     { name: "Dr. Sarah Patel", specialization: "Physiotherapist", degree: "DPT (Doctor of Physical Therapy)", experience: "8 years of experience", tags: ["Sports Injuries", "Manual Therapy", "Chronic Pain"], image: doctorHomeImages.doctor23 }
//   ]
// },
// {
//   id: "spinal-decompression",
//   title: "Spinal Decompression/Traction",
//   captionDescription: "Relieve pressure on the spine.",
//   description: "Spinal decompression therapy is a non-invasive treatment used to relieve pressure on the spinal discs and nerves. This therapy is particularly effective for individuals suffering from herniated discs, sciatica, or chronic back pain. By gently stretching the spine, decompression helps improve blood flow to the affected areas, reduce pain, and promote healing. It offers a non-surgical option for patients seeking relief from spinal conditions.",
//   image: specImages.spec_therapy,
//   link: "/services/spinal-decompression",
//   symptoms: [
//     { title: "Herniated Discs", description: "Pain caused by displaced spinal discs pressing on nerves." },
//     { title: "Sciatica", description: "Sharp pain radiating down the leg due to nerve compression." },
//     { title: "Chronic Back Pain", description: "Persistent discomfort in the lower back due to spinal issues." },
//     { title: "Pinched Nerves", description: "Nerve compression causing pain, tingling, or numbness." },
//     { title: "Spinal Stenosis", description: "Narrowing of the spinal canal leading to pain and stiffness." },
//     { title: "Degenerative Disc Disease", description: "Wear and tear on spinal discs causing pain and reduced flexibility." }
//   ],
//   howItWorks: {
//     description: "Spinal decompression works by gently stretching the spine using specialized equipment or manual techniques. This reduces pressure on the spinal discs, allowing nutrients, oxygen, and fluids to flow back into the affected areas, promoting healing. Decompression can relieve pain associated with herniated discs, sciatica, and other spinal conditions. It’s a non-invasive treatment that offers an alternative to surgery for individuals looking to improve mobility and reduce chronic back pain.",
//     image: specImages.spinalDecompressionHowItWorks
//   },
//   relatedConditions: [
//     { id: "herniated-discs", title: "Herniated Discs", link: "/services/herniated-discs" },
//     { id: "sciatica", title: "Sciatica", link: "/services/sciatica" },
//     { id: "spinal-stenosis", title: "Spinal Stenosis", link: "/services/spinal-stenosis" }
//   ],
//   doctors: [
//     { name: "Dr. James Miller", specialization: "Chiropractor", degree: "D.C. (Doctor of Chiropractic)", experience: "18 years of experience", tags: ["Spinal Decompression", "Herniated Discs", "Chronic Back Pain"], image: doctorHomeImages.doctor24 },
//     { name: "Dr. Olivia Thompson", specialization: "Physiotherapist", degree: "MPT (Orthopedic)", experience: "10 years of experience", tags: ["Spinal Conditions", "Traction Therapy", "Pinched Nerves"], image: doctorHomeImages.doctor25 },
//     { name: "Dr. Ethan Jackson", specialization: "Chiropractor", degree: "D.C. (Doctor of Chiropractic)", experience: "12 years of experience", tags: ["Sciatica", "Spinal Stenosis", "Decompression Therapy"], image: doctorHomeImages.doctor26 }
//   ]
// },
// {
//   id: "virtual-visits-physiotherapy",
//   title: "Virtual Visits for Physiotherapy",
//   captionDescription: "Convenient care from home.",
//   description: "Virtual visits for physiotherapy allow patients to receive expert care from the comfort of their own homes. Using secure video conferencing, physiotherapists can assess, diagnose, and guide patients through personalized treatment plans. Virtual sessions are especially useful for individuals with mobility issues or those living in remote areas. This modern approach to physiotherapy offers flexibility and convenience without compromising on the quality of care.",
//   image: specImages.spec_taping,
//   link: "/services/virtual-visits-physiotherapy",
//   symptoms: [
//     { title: "Chronic Pain", description: "Ongoing pain that impacts daily activities and mobility." },
//     { title: "Post-Surgical Rehab", description: "Recovery from surgery requiring guided exercises." },
//     { title: "Muscle Weakness", description: "Reduced muscle strength due to injury or immobility." },
//     { title: "Balance Issues", description: "Difficulty maintaining balance, leading to falls or instability." },
//     { title: "Joint Stiffness", description: "Limited range of motion due to injury or arthritis." },
//     { title: "Sports Injuries", description: "Rehabilitation for injuries sustained during physical activities." }
//   ],
//   howItWorks: {
//     description: "Virtual physiotherapy sessions are conducted via secure video conferencing platforms. During the session, a physiotherapist will assess the patient’s condition, provide a diagnosis, and guide them through exercises tailored to their needs. These sessions are ideal for individuals who cannot easily visit a clinic, offering the same quality care remotely. Patients can learn stretches, strengthening exercises, and techniques to manage pain or recover from injury in real-time, with expert guidance.",
//     image: specImages.virtualPhysioHowItWorks
//   },
//   relatedConditions: [
//     { id: "chronic-pain", title: "Chronic Pain", link: "/services/chronic-pain" },
//     { id: "sports-injuries", title: "Sports Injuries", link: "/services/sports-injuries" },
//     { id: "joint-stiffness", title: "Joint Stiffness", link: "/services/joint-stiffness" }
//   ],
//   doctors: [
//     { name: "Dr. Olivia Harris", specialization: "Physiotherapist", degree: "DPT (Doctor of Physical Therapy)", experience: "10 years of experience", tags: ["Chronic Pain", "Virtual Therapy", "Post-Surgical Rehab"], image: doctorHomeImages.doctor27 },
//     { name: "Dr. Matthew Collins", specialization: "Physiotherapist", degree: "MPT (Musculoskeletal)", experience: "12 years of experience", tags: ["Sports Injuries", "Joint Stiffness", "Virtual Rehab"], image: doctorHomeImages.doctor28 },
//     { name: "Dr. Emily Parker", specialization: "Physiotherapist", degree: "M.Sc (Physiotherapy)", experience: "8 years of experience", tags: ["Muscle Weakness", "Post-Surgical Rehab", "Virtual Therapy"], image: doctorHomeImages.doctor29 }
//   ]
// },
// {
//   id: "functional-movement-screen",
//   title: "Functional Movement Screen",
//   captionDescription: "Assess and improve movement patterns.",
//   description: "The Functional Movement Screen (FMS) is a tool used by physiotherapists to assess movement patterns and identify dysfunctions that may lead to injury. The test evaluates balance, flexibility, and strength across seven fundamental movements, helping to develop customized treatment plans that enhance performance and reduce injury risk. FMS is beneficial for athletes and individuals recovering from injury, ensuring safe and efficient movement in daily activities or sports.",
//   image: specImages.spec_trigger,
//   link: "/services/functional-movement-screen",
//   symptoms: [
//     { title: "Movement Dysfunction", description: "Inefficient movement patterns that increase injury risk." },
//     { title: "Joint Instability", description: "Weak or unstable joints leading to improper movement." },
//     { title: "Muscle Imbalance", description: "One muscle group is stronger than its opposing group, causing dysfunction." },
//     { title: "Poor Flexibility", description: "Limited range of motion, affecting performance and increasing injury risk." },
//     { title: "Balance Issues", description: "Difficulty maintaining stability during movement." },
//     { title: "Reduced Strength", description: "Insufficient muscle strength impacting functional movement." }
//   ],
//   howItWorks: {
//     description: "Functional Movement Screening (FMS) involves a series of seven basic movements, such as squatting, lunging, and reaching, to assess the body’s mobility, stability, and coordination. Each movement is scored, allowing physiotherapists to identify areas of weakness or dysfunction. Based on the assessment, a tailored plan is created to correct movement inefficiencies, enhance physical performance, and prevent injury. FMS is commonly used by athletes and individuals recovering from injury to ensure they are moving safely and effectively.",
//     image: specImages.functionalMovementHowItWorks
//   },
//   relatedConditions: [
//     { id: "sports-injuries", title: "Sports Injuries", link: "/services/sports-injuries" },
//     { id: "balance-issues", title: "Balance Issues", link: "/services/balance-issues" },
//     { id: "joint-instability", title: "Joint Instability", link: "/services/joint-instability" }
//   ],
//   doctors: [
//     { name: "Dr. Jason Mitchell", specialization: "Physiotherapist", degree: "MPT (Musculoskeletal)", experience: "12 years of experience", tags: ["Movement Assessment", "Functional Training", "Injury Prevention"], image: doctorHomeImages.doctor30 },
//     { name: "Dr. Laura Simmons", specialization: "Physiotherapist", degree: "DPT (Doctor of Physical Therapy)", experience: "9 years of experience", tags: ["Athlete Recovery", "Muscle Imbalance", "Functional Screening"], image: doctorHomeImages.doctor31 },
//     { name: "Dr. Richard Evans", specialization: "Orthopedic Specialist", degree: "M.D. (Orthopedics)", experience: "15 years of experience", tags: ["Joint Instability", "Sports Injuries", "Functional Movement"], image: doctorHomeImages.doctor32 }
//   ]
// },
// {
//   id: "geriatric-physical-therapy",
//   title: "Geriatric Physical Therapy",
//   captionDescription: "Support for aging adults.",
//   description: "Geriatric physical therapy is designed to address the unique mobility and health challenges that come with aging. By focusing on balance, flexibility, and strength, this therapy aims to enhance the independence and overall quality of life for older adults. It is beneficial for managing conditions such as arthritis, osteoporosis, and recovering from falls, as well as improving overall mobility, balance, and endurance to help seniors live more active lives.",
//   image: specImages.spec_therapy,
//   link: "/services/geriatric-physical-therapy",
//   symptoms: [
//     { title: "Joint Pain", description: "Pain due to conditions like arthritis that affect mobility." },
//     { title: "Balance Issues", description: "Loss of balance, increasing the risk of falls and injuries." },
//     { title: "Muscle Weakness", description: "Reduced muscle strength impacting daily activities." },
//     { title: "Limited Mobility", description: "Difficulty moving due to aging or medical conditions." },
//     { title: "Osteoporosis", description: "Bone thinning causing fractures and reduced strength." },
//     { title: "Post-Surgical Recovery", description: "Support after surgery to regain mobility and strength." }
//   ],
//   howItWorks: {
//     description: "Geriatric physical therapy focuses on improving strength, flexibility, balance, and endurance in older adults. Therapists design customized exercise programs aimed at managing pain from conditions like arthritis, improving mobility, and reducing the risk of falls. The therapy involves low-impact exercises, balance training, and techniques like stretching to increase range of motion. Geriatric therapy also helps with post-surgical recovery, ensuring that older adults regain their independence and mobility safely.",
//     image: specImages.spec_massage
//   },
//   relatedConditions: [
//     { id: "arthritis", title: "Arthritis", link: "/services/arthritis" },
//     { id: "balance-issues", title: "Balance Issues", link: "/services/balance-issues" },
//     { id: "osteoporosis", title: "Osteoporosis", link: "/services/osteoporosis" }
//   ],
//   doctors: [
//     { name: "Dr. Hannah Evans", specialization: "Geriatric Physiotherapist", degree: "MPT (Geriatrics)", experience: "15 years of experience", tags: ["Joint Pain", "Post-Surgical Recovery", "Fall Prevention"], image: doctorHomeImages.doctor33 },
//     { name: "Dr. Samuel Thompson", specialization: "Physical Therapist", degree: "DPT (Doctor of Physical Therapy)", experience: "18 years of experience", tags: ["Osteoporosis", "Mobility Training", "Geriatric Rehabilitation"], image: doctorHomeImages.doctor34 },
//     { name: "Dr. Rachel Scott", specialization: "Rehabilitation Specialist", degree: "M.Sc (Rehabilitation)", experience: "12 years of experience", tags: ["Balance Training", "Arthritis", "Geriatric Therapy"], image: doctorHomeImages.doctor35 }
//   ]
// },
// {
//   id: "joint-mobilization",
//   title: "Joint Mobilization",
//   captionDescription: "Relieve stiffness and improve joint function.",
//   description: "Joint mobilization is a hands-on technique used to restore joint movement and relieve stiffness. It involves applying controlled forces to a joint to increase its range of motion and reduce pain. This technique is commonly used for conditions such as arthritis, frozen shoulder, and after surgery to help patients regain flexibility and mobility.",
//   image: specImages.spec_physiotherapy,
//   link: "/services/joint-mobilization",
//   symptoms: [
//     { title: "Joint Stiffness", description: "Difficulty moving the joint due to stiffness." },
//     { title: "Reduced Range of Motion", description: "Limited joint movement caused by various conditions." },
//     { title: "Pain with Movement", description: "Pain when moving the joint, especially in the morning." },
//     { title: "Swelling", description: "Swollen joints often associated with injury or arthritis." },
//     { title: "Post-Surgical Stiffness", description: "Stiffness after surgery that limits mobility." },
//     { title: "Arthritis Pain", description: "Chronic pain in joints due to arthritis." }
//   ],
//   howItWorks: {
//     description: "Joint mobilization involves applying gentle, controlled pressure to stiff joints to improve range of motion and reduce pain. This manual therapy technique is effective in relieving discomfort caused by arthritis, injuries, or post-surgical stiffness. By gently moving the joint through its natural range, therapists can reduce stiffness, enhance flexibility, and support overall joint health. Regular joint mobilization sessions can significantly improve mobility and quality of life for patients with joint issues.",
//     image: specImages.jointMobilizationHowItWorks
//   },
//   relatedConditions: [
//     { id: "arthritis", title: "Arthritis", link: "/services/arthritis" },
//     { id: "frozen-shoulder", title: "Frozen Shoulder", link: "/services/frozen-shoulder" },
//     { id: "post-surgical-rehabilitation", title: "Post-Surgical Rehabilitation", link: "/services/post-surgical-rehabilitation" }
//   ],
//   doctors: [
//     { name: "Dr. Emma Jones", specialization: "Orthopedic Physiotherapist", degree: "MPT (Ortho)", experience: "10 years of experience", tags: ["Joint Mobilization", "Arthritis", "Post-Surgical Recovery"], image: doctorHomeImages.doctor21 },
//     { name: "Dr. Oliver Green", specialization: "Physiotherapist", degree: "BPT", experience: "12 years of experience", tags: ["Joint Pain", "Manual Therapy", "Rehabilitation"], image: doctorHomeImages.doctor22 },
//     { name: "Dr. Sophia Harris", specialization: "Orthopedic Specialist", degree: "MD (Orthopedics)", experience: "14 years of experience", tags: ["Joint Pain", "Post-Surgical Care", "Arthritis"], image: doctorHomeImages.doctor23 }
//   ]
// },

// {
//   id: "mulligan-technique",
//   title: "Mulligan Technique",
//   captionDescription: "Improve joint alignment and reduce pain.",
//   description: "The Mulligan Technique is a manual therapy approach that combines joint mobilization with movement. This technique is used to relieve pain and restore normal joint function by addressing joint misalignment and mechanical restrictions. It is commonly applied to treat issues like neck pain, shoulder pain, and knee problems, enabling better movement and reduced discomfort.",
//   image: specImages.spec_orthotics,
//   link: "/services/mulligan-technique",
//   symptoms: [
//     { title: "Joint Misalignment", description: "Pain and restricted movement due to joint misalignment." },
//     { title: "Stiffness", description: "Stiffness in joints affecting mobility." },
//     { title: "Reduced Mobility", description: "Difficulty moving the joint due to mechanical restrictions." },
//     { title: "Post-Injury Pain", description: "Pain resulting from joint misalignment after an injury." },
//     { title: "Neck Pain", description: "Pain and stiffness in the neck caused by joint misalignment." },
//     { title: "Shoulder Pain", description: "Restricted movement and discomfort in the shoulder." }
//   ],
//   howItWorks: {
//     description: "The Mulligan Technique focuses on realigning joints through gentle mobilization combined with patient movement. A therapist applies pressure to the joint while the patient performs movements that were previously painful or restricted. This combination of joint repositioning and active movement helps reduce pain, restore function, and improve overall mobility. The Mulligan Technique is especially useful for conditions involving joint misalignment, allowing patients to experience relief and regain full motion in their joints.",
//     image: specImages.mulliganTechniqueHowItWorks
//   },
//   relatedConditions: [
//     { id: "neck-pain", title: "Neck Pain", link: "/services/neck-pain" },
//     { id: "shoulder-pain", title: "Shoulder Pain", link: "/services/shoulder-pain" },
//     { id: "knee-pain", title: "Knee Pain", link: "/services/knee-pain" }
//   ],
//   doctors: [
//     { name: "Dr. Alan Stewart", specialization: "Manual Therapist", degree: "MPT (Manual Therapy)", experience: "11 years of experience", tags: ["Joint Alignment", "Pain Relief", "Rehabilitation"], image: doctorHomeImages.doctor24 },
//     { name: "Dr. Karen Wilson", specialization: "Orthopedic Physiotherapist", degree: "MPT (Ortho)", experience: "13 years of experience", tags: ["Mulligan Technique", "Joint Pain", "Neck and Shoulder Pain"], image: doctorHomeImages.doctor25 },
//     { name: "Dr. Peter Richards", specialization: "Sports Therapist", degree: "BPT", experience: "9 years of experience", tags: ["Sports Injuries", "Joint Mobilization", "Manual Therapy"], image: doctorHomeImages.doctor26 }
//   ]
// },

// {
//   id: "neuromobilization",
//   title: "Neuromobilization",
//   captionDescription: "Restore nerve function and mobility.",
//   description: "Neuromobilization is a technique used to restore normal movement to nerves that have been restricted or compressed. It helps alleviate pain, numbness, and tingling associated with conditions like sciatica, carpal tunnel syndrome, or nerve injuries. Neuromobilization focuses on improving nerve mobility, reducing discomfort, and restoring proper function.",
//   image: specImages.spec_mckinze,
//   link: "/services/neuromobilization",
//   symptoms: [
//     { title: "Nerve Compression", description: "Pain and numbness due to compressed nerves." },
//     { title: "Sciatica", description: "Shooting pain down the leg caused by nerve irritation." },
//     { title: "Carpal Tunnel Syndrome", description: "Nerve compression in the wrist causing pain and tingling." },
//     { title: "Numbness", description: "Loss of sensation in affected areas due to nerve compression." },
//     { title: "Tingling Sensation", description: "Tingling in limbs due to restricted nerve movement." },
//     { title: "Limited Mobility", description: "Difficulty moving affected body parts due to nerve issues." }
//   ],
//   howItWorks: {
//     description: "Neuromobilization involves gentle techniques to restore mobility to nerves that are compressed or restricted. A therapist applies specific movements to free the nerve from surrounding tissues, allowing it to glide and function properly. This technique reduces pain, numbness, and tingling associated with nerve compression. Neuromobilization is effective for conditions like sciatica, carpal tunnel syndrome, and nerve injuries, helping patients regain mobility and reducing nerve-related discomfort.",
//     image: specImages.neuromobilizationHowItWorks
//   },
//   relatedConditions: [
//     { id: "sciatica", title: "Sciatica", link: "/services/sciatica" },
//     { id: "carpal-tunnel-syndrome", title: "Carpal Tunnel Syndrome", link: "/services/carpal-tunnel-syndrome" },
//     { id: "nerve-injuries", title: "Nerve Injuries", link: "/services/nerve-injuries" }
//   ],
//   doctors: [
//     { name: "Dr. Lisa Collins", specialization: "Neurological Physiotherapist", degree: "MPT (Neuro)", experience: "14 years of experience", tags: ["Neuromobilization", "Sciatica", "Nerve Compression"], image: doctorHomeImages.doctor27 },
//     { name: "Dr. Thomas Reid", specialization: "Orthopedic Physiotherapist", degree: "MPT (Ortho)", experience: "12 years of experience", tags: ["Nerve Injuries", "Rehabilitation", "Neuromobilization"], image: doctorHomeImages.doctor28 },
//     { name: "Dr. Sarah Lee", specialization: "Sports Therapist", degree: "BPT", experience: "10 years of experience", tags: ["Carpal Tunnel", "Neuromobilization", "Nerve Injuries"], image: doctorHomeImages.doctor29 }
//   ]
// },
// {
//   id: "other-modalities",
//   title: "Other Modalities",
//   captionDescription: "Innovative therapies for comprehensive care.",
//   description: "Other modalities refer to a variety of advanced therapeutic techniques that aim to improve healing, relieve pain, and restore function. These methods include electrical stimulation, ultrasound, and laser therapy, all designed to support faster recovery and enhance the body's natural healing processes. Used in conjunction with traditional physical therapy, these modalities provide a holistic approach to patient care.",
//   image: specImages.spec_physiotherapy,
//   link: "/services/other-modalities",
//   symptoms: [
//     { title: "Chronic Pain", description: "Long-term discomfort that affects daily activities." },
//     { title: "Muscle Spasms", description: "Involuntary contractions causing pain and stiffness." },
//     { title: "Inflammation", description: "Swelling and discomfort in affected areas." },
//     { title: "Poor Circulation", description: "Reduced blood flow leading to tissue damage and pain." },
//     { title: "Scar Tissue", description: "Formation of thick tissue post-injury or surgery." },
//     { title: "Nerve Damage", description: "Damage to nerves resulting in pain and numbness." }
//   ],
//   howItWorks: {
//     description: "Other modalities involve a variety of advanced therapeutic tools and techniques used in physical therapy. Electrical stimulation promotes muscle contraction and helps reduce pain. Ultrasound therapy uses sound waves to stimulate deep tissues, reducing inflammation and improving circulation. Laser therapy speeds up the healing process by promoting cellular regeneration. These modalities complement traditional therapy by providing targeted treatment to affected areas, enhancing recovery, and relieving pain. They are used to treat chronic pain, inflammation, and nerve damage, helping patients regain their function.",
//     image: specImages.otherModalitiesHowItWorks
//   },
//   relatedConditions: [
//     { id: "chronic-pain", title: "Chronic Pain", link: "/services/chronic-pain" },
//     { id: "nerve-damage", title: "Nerve Damage", link: "/services/nerve-damage" },
//     { id: "post-surgical-rehabilitation", title: "Post-Surgical Rehabilitation", link: "/services/post-surgical-rehabilitation" }
//   ],
//   doctors: [
//     { name: "Dr. Emily Foster", specialization: "Physical Therapist", degree: "MPT (Rehabilitation)", experience: "15 years of experience", tags: ["Advanced Modalities", "Chronic Pain", "Rehabilitation"], image: doctorHomeImages.doctor11 },
//     { name: "Dr. James Lee", specialization: "Orthopedic Specialist", degree: "MD (Orthopedics)", experience: "20 years of experience", tags: ["Muscle Recovery", "Post-Surgical Care", "Pain Management"], image: doctorHomeImages.doctor12 },
//     { name: "Dr. Grace Thomas", specialization: "Neurological Physiotherapist", degree: "MPT (Neuro)", experience: "12 years of experience", tags: ["Nerve Damage", "Chronic Pain", "Advanced Therapies"], image: doctorHomeImages.doctor13 }
//   ]
// },
// {
//   id: "peripheral-neuropathy",
//   title: "Peripheral Neuropathy",
//   captionDescription: "Treat nerve pain and restore sensation.",
//   description: "Peripheral neuropathy is a condition that affects the peripheral nerves, causing pain, numbness, and weakness, particularly in the hands and feet. This condition can result from diabetes, infections, or trauma and often leads to a loss of sensation or muscle control. Treatment aims to alleviate pain, restore sensation, and prevent further nerve damage, allowing patients to regain control over their motor skills and improve their quality of life.",
//   image: specImages.spec_therapy,
//   link: "/services/peripheral-neuropathy",
//   symptoms: [
//     { title: "Numbness", description: "Loss of sensation in the affected areas." },
//     { title: "Tingling", description: "A pins-and-needles sensation in the hands or feet." },
//     { title: "Burning Pain", description: "A burning sensation that worsens at night." },
//     { title: "Muscle Weakness", description: "Loss of strength in the affected limbs." },
//     { title: "Sensitivity to Touch", description: "Heightened pain from light touch or pressure." },
//     { title: "Coordination Issues", description: "Difficulty controlling muscles in the affected areas." }
//   ],
//   howItWorks: {
//     description: "Peripheral neuropathy treatment focuses on managing symptoms and preventing further nerve damage. Physical therapy helps improve muscle strength and coordination, while specific exercises can increase flexibility and balance. Medications such as pain relievers and anti-inflammatory drugs are used to reduce nerve pain and inflammation. Electrical stimulation and other modalities may also be employed to promote nerve regeneration and alleviate symptoms. Addressing underlying causes such as diabetes or infections is crucial for preventing further deterioration and improving overall nerve function.",
//     image: specImages.peripheralNeuropathyHowItWorks
//   },
//   relatedConditions: [
//     { id: "diabetes-related-neuropathy", title: "Diabetes-Related Neuropathy", link: "/services/diabetes-related-neuropathy" },
//     { id: "nerve-damage", title: "Nerve Damage", link: "/services/nerve-damage" },
//     { id: "chronic-pain", title: "Chronic Pain", link: "/services/chronic-pain" }
//   ],
//   doctors: [
//     { name: "Dr. Samuel Brown", specialization: "Neurological Physiotherapist", degree: "MPT (Neuro)", experience: "12 years of experience", tags: ["Nerve Pain", "Peripheral Neuropathy", "Rehabilitation"], image: doctorHomeImages.doctor14 },
//     { name: "Dr. Angela Turner", specialization: "Endocrinologist", degree: "MD (Endocrinology)", experience: "18 years of experience", tags: ["Diabetes-Related Neuropathy", "Nerve Damage", "Pain Management"], image: doctorHomeImages.doctor15 },
//     { name: "Dr. Jason Patel", specialization: "Physical Therapist", degree: "MPT (Rehabilitation)", experience: "10 years of experience", tags: ["Muscle Recovery", "Nerve Damage", "Peripheral Neuropathy"], image: doctorHomeImages.doctor16 }
//   ]
// },
// {
//   id: "phonophoresis",
//   title: "Phonophoresis",
//   captionDescription: "Medication delivery via ultrasound.",
//   description: "Phonophoresis is a non-invasive treatment that uses ultrasound to enhance the absorption of topical medications, often anti-inflammatory or analgesic creams, through the skin. This technique is commonly used to treat soft tissue injuries, tendonitis, and bursitis, helping reduce inflammation and promote healing. By using ultrasound waves, phonophoresis helps deliver medication directly to the affected tissues, offering pain relief and reducing the need for oral medications.",
//   image: specImages.spec_massage,
//   link: "/services/phonophoresis",
//   symptoms: [
//     { title: "Tendonitis", description: "Inflammation of tendons causing pain and restricted movement." },
//     { title: "Bursitis", description: "Swelling and irritation of fluid-filled sacs around joints." },
//     { title: "Soft Tissue Injuries", description: "Tears or strains in muscles, tendons, or ligaments." },
//     { title: "Joint Pain", description: "Pain or discomfort in the joints due to injury or inflammation." },
//     { title: "Muscle Spasms", description: "Involuntary muscle contractions causing pain and stiffness." },
//     { title: "Inflammation", description: "Swelling and discomfort in the affected areas." }
//   ],
//   howItWorks: {
//     description: "Phonophoresis works by using ultrasound waves to increase the permeability of the skin, allowing medications applied topically to penetrate deeper into tissues. The treatment is often used in physical therapy to treat conditions like tendonitis, bursitis, and soft tissue injuries. During the procedure, the therapist applies the medication to the affected area and uses an ultrasound device to send sound waves through the skin, enhancing the drug's absorption. This method provides targeted relief and can reduce the need for oral medications or injections.",
//     image: specImages.phonophoresisHowItWorks
//   },
//   relatedConditions: [
//     { id: "tendonitis", title: "Tendonitis", link: "/services/tendonitis" },
//     { id: "bursitis", title: "Bursitis", link: "/services/bursitis" },
//     { id: "soft-tissue-injury", title: "Soft Tissue Injury", link: "/services/soft-tissue-injury" }
//   ],
//   doctors: [
//     { name: "Dr. Jason Brown", specialization: "Physical Therapist", degree: "MPT (Rehabilitation)", experience: "12 years of experience", tags: ["Phonophoresis", "Soft Tissue Injuries", "Tendonitis"], image: doctorHomeImages.doctor17 },
//     { name: "Dr. Maria Thompson", specialization: "Sports Physiotherapist", degree: "M.Sc (Sports Physio)", experience: "15 years of experience", tags: ["Sports Injuries", "Phonophoresis", "Pain Management"], image: doctorHomeImages.doctor18 },
//     { name: "Dr. Steven Patel", specialization: "Orthopedic Specialist", degree: "MD (Orthopedics)", experience: "18 years of experience", tags: ["Bursitis", "Joint Pain", "Rehabilitation"], image: doctorHomeImages.doctor19 }
//   ]
// },
// {
//   id: "podiatrist-service",
//   title: "Podiatrist Service",
//   captionDescription: "Expert foot and ankle care.",
//   description: "Podiatrist services focus on diagnosing, treating, and preventing conditions affecting the foot and ankle. From common foot problems like bunions and plantar fasciitis to more serious conditions such as fractures and diabetic foot complications, podiatry offers specialized care. With a variety of treatments including orthotics, physical therapy, and surgical interventions, podiatrists help restore foot function, reduce pain, and improve overall mobility.",
//   image: specImages.spec_laser,
//   link: "/services/podiatrist-service",
//   symptoms: [
//     { title: "Bunions", description: "Painful bony lumps that form on the side of the foot." },
//     { title: "Plantar Fasciitis", description: "Inflammation of the tissue connecting the heel to the toes." },
//     { title: "Flat Feet", description: "A condition where the arch of the foot is flattened." },
//     { title: "Foot Fractures", description: "Breaks or cracks in the bones of the foot." },
//     { title: "Achilles Tendonitis", description: "Inflammation of the Achilles tendon causing pain and stiffness." },
//     { title: "Diabetic Foot Complications", description: "Foot problems caused by poor circulation and nerve damage in diabetics." }
//   ],
//   howItWorks: {
//     description: "Podiatrist services involve a comprehensive approach to diagnosing and treating foot and ankle conditions. After an initial assessment, treatment plans may include custom orthotics to provide support, physical therapy to strengthen the foot muscles, and medication to manage pain and inflammation. In more severe cases, surgery may be recommended to correct structural issues or repair damage. Preventive care, such as routine foot check-ups and management of conditions like diabetes, is also essential for maintaining foot health and preventing long-term complications.",
//     image: specImages.podiatristHowItWorks
//   },
//   relatedConditions: [
//     { id: "plantar-fasciitis", title: "Plantar Fasciitis", link: "/services/plantar-fasciitis" },
//     { id: "bunion", title: "Bunion", link: "/services/bunion" },
//     { id: "achilles-tendonitis", title: "Achilles Tendonitis", link: "/services/achilles-tendonitis" }
//   ],
//   doctors: [
//     { name: "Dr. Samantha Green", specialization: "Podiatrist", degree: "DPM (Podiatry)", experience: "14 years of experience", tags: ["Foot Surgery", "Diabetic Foot Care", "Orthotics"], image: doctorHomeImages.doctor20 },
//     { name: "Dr. Oliver Johnson", specialization: "Foot and Ankle Surgeon", degree: "MD (Orthopedics)", experience: "16 years of experience", tags: ["Foot Fractures", "Ankle Injuries", "Surgical Care"], image: doctorHomeImages.doctor21 },
//     { name: "Dr. Christina Yang", specialization: "Podiatrist", degree: "DPM (Podiatry)", experience: "12 years of experience", tags: ["Bunions", "Plantar Fasciitis", "Pediatric Podiatry"], image: doctorHomeImages.doctor22 }
//   ]
// },

// {
//   id: "postural-restoration",
//   title: "Postural Restoration",
//   captionDescription: "Correct postural imbalances and pain.",
//   description: "Postural restoration therapy addresses imbalances in the body’s alignment that can lead to chronic pain and discomfort. By focusing on the relationship between the muscles, bones, and joints, therapists develop individualized plans to restore proper posture. This therapy helps relieve pain caused by poor posture, muscle imbalances, and improper movement patterns, improving overall body mechanics and function.",
//   image: specImages.spec_taping,
//   link: "/services/postural-restoration",
//   symptoms: [
//     { title: "Back Pain", description: "Chronic discomfort in the lower or upper back due to poor posture." },
//     { title: "Neck Strain", description: "Tension and stiffness in the neck muscles." },
//     { title: "Shoulder Imbalance", description: "Misalignment of the shoulders causing pain and restricted movement." },
//     { title: "Pelvic Tilt", description: "Uneven positioning of the pelvis leading to hip and lower back pain." },
//     { title: "Foot Misalignment", description: "Improper positioning of the feet affecting gait and posture." },
//     { title: "Joint Pain", description: "Pain in the joints caused by improper body mechanics." }
//   ],
//   howItWorks: {
//     description: "Postural restoration therapy works by identifying and correcting postural imbalances that affect the body’s ability to move efficiently. During the assessment, therapists examine the alignment of the pelvis, spine, shoulders, and other key areas to identify any asymmetries or improper movement patterns. Treatment involves exercises designed to retrain the muscles, improve balance, and restore proper body mechanics. This therapy can prevent further injury, reduce pain, and improve overall physical function by ensuring that the body moves in a more aligned and balanced way.",
//     image: specImages.posturalRestorationHowItWorks
//   },
//   relatedConditions: [
//     { id: "back-pain", title: "Back Pain", link: "/services/back-pain" },
//     { id: "neck-pain", title: "Neck Pain", link: "/services/neck-pain" },
//     { id: "shoulder-pain", title: "Shoulder Pain", link: "/services/shoulder-pain" }
//   ],
//   doctors: [
//     {
//       name: "Dr. Emily Harper",
//       specialization: "Physical Therapist",
//       degree: "MPT (Orthopedics)",
//       experience: "14 years of experience",
//       tags: ["Postural Restoration", "Chronic Pain", "Spine Health"],
//       image: doctorHomeImages.doctor23
//     },
//     {
//       name: "Dr. William Scott",
//       specialization: "Chiropractor",
//       degree: "DC (Chiropractic Medicine)",
//       experience: "18 years of experience",
//       tags: ["Postural Alignment", "Spinal Disorders", "Rehabilitation"],
//       image: doctorHomeImages.doctor24
//     },
//     {
//       name: "Dr. Jenna Reid",
//       specialization: "Rehabilitation Specialist",
//       degree: "PhD (Rehabilitation Sciences)",
//       experience: "12 years of experience",
//       tags: ["Posture Correction", "Joint Pain", "Mobility Improvement"],
//       image: doctorHomeImages.doctor25
//     }
//   ]
// },
// {
//   id: "pre-post-natal-pain",
//   title: "Pre/Post Natal Pain",
//   captionDescription: "Manage pain during and after pregnancy.",
//   description: "Pre/Post natal pain management addresses discomforts commonly experienced during pregnancy and after childbirth. Hormonal changes, weight gain, and postural shifts can lead to back, pelvic, and joint pain. Specialized therapies are designed to relieve pain, improve mobility, and prepare the body for delivery while promoting recovery post-birth. Physical therapy during this period is essential to ensure both the mother's comfort and long-term physical health.",
//   image: specImages.spec_orthotics,
//   link: "/services/pre-post-natal-pain",
//   symptoms: [
//     { title: "Lower Back Pain", description: "Pain caused by the growing weight of the baby and posture changes." },
//     { title: "Pelvic Pain", description: "Discomfort due to ligament loosening and pressure on the pelvis." },
//     { title: "Hip Pain", description: "Hip joint strain from body weight shifts during pregnancy." },
//     { title: "Sciatica", description: "Shooting pain down the legs due to nerve pressure in the lower back." },
//     { title: "Abdominal Discomfort", description: "Muscle pain from abdominal stretching during pregnancy." },
//     { title: "Postpartum Joint Pain", description: "Aching joints after delivery due to hormonal shifts and physical strain." }
//   ],
//   howItWorks: {
//     description: "Pre and postnatal therapy works by targeting the specific areas of the body affected by pregnancy and childbirth. Before delivery, physical therapists focus on gentle exercises and techniques to relieve pressure on the back, hips, and pelvis, helping mothers-to-be manage pain and improve mobility. After childbirth, therapy aims to restore core strength, address postpartum joint pain, and help mothers regain their pre-pregnancy physical function. Customized treatment plans often include pelvic floor exercises, gentle stretches, and strength training to ensure proper recovery and long-term well-being.",
//     image: specImages.prePostNatalHowItWorks
//   },
//   relatedConditions: [
//     { id: "lower-back-pain", title: "Lower Back Pain", link: "/services/lower-back-pain" },
//     { id: "pelvic-pain", title: "Pelvic Pain", link: "/services/pelvic-pain" },
//     { id: "sciatica", title: "Sciatica", link: "/services/sciatica" }
//   ],
//   doctors: [
//     {
//       name: "Dr. Hannah Blake",
//       specialization: "Women's Health Physiotherapist",
//       degree: "M.Sc (Women's Health)",
//       experience: "10 years of experience",
//       tags: ["Pregnancy Pain", "Postpartum Recovery", "Pelvic Floor Therapy"],
//       image: doctorHomeImages.doctor26
//     },
//     {
//       name: "Dr. Sarah Coleman",
//       specialization: "Prenatal Specialist",
//       degree: "PhD (Physiotherapy)",
//       experience: "12 years of experience",
//       tags: ["Pre/Post Natal Care", "Pregnancy Pain", "Women's Health"],
//       image: doctorHomeImages.doctor27
//     },
//     {
//       name: "Dr. Lucy Hall",
//       specialization: "Physical Therapist",
//       degree: "MPT (Physiotherapy)",
//       experience: "8 years of experience",
//       tags: ["Pre/Post Natal Therapy", "Pelvic Pain", "Joint Pain"],
//       image: doctorHomeImages.doctor28
//     }
//   ]
// },
// {
//   id: "return-to-sports",
//   title: "Return to Sports",
//   captionDescription: "Get back to your best after injury.",
//   description: "The Return to Sports program focuses on helping athletes recover from injury and regain their pre-injury performance levels. It combines physical therapy, strength training, and sport-specific exercises to restore mobility, endurance, and coordination. Whether recovering from surgery or muscle strains, this program is tailored to individual needs, ensuring a safe and effective return to sport while minimizing the risk of re-injury.",
//   image: specImages.spec_electric,
//   link: "/services/return-to-sports",
//   symptoms: [
//     { title: "Reduced Range of Motion", description: "Limited movement caused by muscle or joint stiffness." },
//     { title: "Muscle Weakness", description: "Loss of strength in key muscle groups after injury." },
//     { title: "Instability", description: "Joint instability leading to difficulty in performing movements." },
//     { title: "Fatigue", description: "Decreased stamina and endurance following inactivity." },
//     { title: "Pain During Movement", description: "Persistent pain when attempting sports-related activities." },
//     { title: "Fear of Re-Injury", description: "Mental barrier due to previous injury trauma." }
//   ],
//   howItWorks: {
//     description: "The Return to Sports program is designed to bridge the gap between rehabilitation and sports performance. Initially, physical therapists work on restoring joint mobility and reducing pain through targeted exercises and manual therapy. As the athlete progresses, strength and conditioning exercises are introduced to enhance muscle power, endurance, and coordination. The program also incorporates sport-specific drills to rebuild confidence and performance in the athlete's respective sport. Emphasis is placed on injury prevention, ensuring the athlete can return to sports activities without risking re-injury.",
//     image: specImages.returnToSportsHowItWorks
//   },
//   relatedConditions: [
//     { id: "sports-injuries", title: "Sports Injuries", link: "/services/sports-injuries" },
//     { id: "muscle-strain", title: "Muscle Strain", link: "/services/muscle-strain" },
//     { id: "joint-pain", title: "Joint Pain", link: "/services/joint-pain" }
//   ],
//   doctors: [
//     {
//       name: "Dr. Robert King",
//       specialization: "Sports Therapist",
//       degree: "MPT (Sports Therapy)",
//       experience: "15 years of experience",
//       tags: ["Sports Injuries", "Rehabilitation", "Return to Sports"],
//       image: doctorHomeImages.doctor29
//     },
//     {
//       name: "Dr. Laura Morgan",
//       specialization: "Orthopedic Specialist",
//       degree: "MD (Orthopedics)",
//       experience: "12 years of experience",
//       tags: ["Sports Injuries", "Post-Surgery Rehabilitation", "Joint Pain"],
//       image: doctorHomeImages.doctor30
//     },
//     {
//       name: "Dr. John Collins",
//       specialization: "Rehabilitation Specialist",
//       degree: "PhD (Rehabilitation Sciences)",
//       experience: "10 years of experience",
//       tags: ["Sports Rehabilitation", "Injury Prevention", "Strength Training"],
//       image: doctorHomeImages.doctor31
//     }
//   ]
// },
// {
//   id: "taping",
//   title: "Taping",
//   captionDescription: "Stabilize joints and muscles.",
//   description: "Taping is a widely used technique in physical therapy to support injured joints, reduce swelling, and prevent further injury. It involves applying adhesive strips to muscles or joints to limit excessive movement, allowing the tissues to heal faster. Taping is particularly beneficial for athletes and individuals recovering from ligament injuries, helping to restore function and mobility while protecting the affected area during physical activity.",
//   image: specImages.spec_massage,
//   link: "/services/taping",
//   symptoms: [
//     { title: "Swelling", description: "Inflammation causing pain and restricted movement in joints." },
//     { title: "Muscle Strain", description: "Overstretched muscles leading to discomfort and instability." },
//     { title: "Joint Instability", description: "Loose joints increasing the risk of injury during physical activity." },
//     { title: "Ligament Injuries", description: "Damaged ligaments causing pain and loss of function." },
//     { title: "Tendinitis", description: "Inflamed tendons resulting in pain and limited movement." },
//     { title: "Post-Surgical Recovery", description: "Weakness or instability following surgery, requiring support." }
//   ],
//   howItWorks: {
//     description: "Taping works by providing external support to injured or weakened muscles and joints. Special adhesive strips, such as kinesio tape or athletic tape, are applied in specific patterns to limit movement, reduce swelling, and promote faster healing. The tape lifts the skin slightly, improving circulation and reducing pressure on the tissues underneath. This technique not only prevents further injury but also allows the individual to continue participating in physical activities safely. Taping is often combined with physical therapy to enhance recovery.",
//     image: specImages.tapingHowItWorks
//   },
//   relatedConditions: [
//     { id: "ligament-injuries", title: "Ligament Injuries", link: "/services/ligament-injuries" },
//     { id: "muscle-strain", title: "Muscle Strain", link: "/services/muscle-strain" },
//     { id: "joint-instability", title: "Joint Instability", link: "/services/joint-instability" }
//   ],
//   doctors: [
//     {
//       name: "Dr. Sarah Hughes",
//       specialization: "Physiotherapist",
//       degree: "MPT (Sports Therapy)",
//       experience: "12 years of experience",
//       tags: ["Sports Injuries", "Muscle Strain", "Ligament Injuries"],
//       image: doctorHomeImages.doctor1
//     },
//     {
//       name: "Dr. Michael Scott",
//       specialization: "Orthopedic Specialist",
//       degree: "MD (Orthopedics)",
//       experience: "15 years of experience",
//       tags: ["Ligament Injuries", "Tendinitis", "Post-Surgical Rehab"],
//       image: doctorHomeImages.doctor2
//     },
//     {
//       name: "Dr. Olivia Martin",
//       specialization: "Sports Rehabilitation Expert",
//       degree: "PhD (Rehabilitation Sciences)",
//       experience: "10 years of experience",
//       tags: ["Sports Injuries", "Post-Surgery Recovery", "Taping"],
//       image: doctorHomeImages.doctor3
//     }
//   ]
// },
// {
//   id: "total-joint-replacement",
//   title: "Total Joint Replacement",
//   captionDescription: "Restoring joint function after surgery.",
//   description: "Total joint replacement is a surgical procedure designed to restore the function of severely damaged or arthritic joints by replacing them with artificial implants. This procedure is often recommended for patients with chronic joint pain that affects their quality of life. Physical therapy plays a critical role in post-surgical recovery, helping individuals regain mobility, strength, and flexibility. This treatment focuses on gradually restoring function while preventing complications and enhancing long-term outcomes.",
//   image: specImages.spec_trigger,
//   link: "/services/total-joint-replacement",
//   symptoms: [
//     { title: "Severe Joint Pain", description: "Chronic pain in joints that limits mobility and daily activities." },
//     { title: "Joint Stiffness", description: "Difficulty in moving the joint due to inflammation or damage." },
//     { title: "Loss of Mobility", description: "Inability to perform everyday movements due to joint deterioration." },
//     { title: "Swelling", description: "Persistent swelling in the joint causing discomfort and reduced function." },
//     { title: "Joint Instability", description: "Unstable joint movement leading to falls or difficulty walking." },
//     { title: "Arthritis", description: "Chronic inflammation and pain in the joint, often leading to surgery." }
//   ],
//   howItWorks: {
//     description: "Total joint replacement surgery involves removing the damaged parts of the joint and replacing them with prosthetic implants made of metal, plastic, or ceramic. After surgery, physical therapy is essential to promote healing and regain strength in the muscles surrounding the joint. Therapists work closely with patients to develop personalized exercise plans that restore joint flexibility and range of motion while minimizing pain. Regular follow-ups with the surgeon and physical therapist are crucial to monitor progress and ensure a successful recovery.",
//     image: specImages.jointReplacementHowItWorks
//   },
//   relatedConditions: [
//     { id: "arthritis", title: "Arthritis", link: "/services/arthritis" },
//     { id: "joint-pain", title: "Joint Pain", link: "/services/joint-pain" },
//     { id: "post-surgical-rehab", title: "Post-Surgical Rehab", link: "/services/post-surgical-rehab" }
//   ],
//   doctors: [
//     {
//       name: "Dr. Emma Johnson",
//       specialization: "Orthopedic Surgeon",
//       degree: "MD (Orthopedic Surgery)",
//       experience: "20 years of experience",
//       tags: ["Joint Replacement", "Arthritis Treatment", "Post-Surgical Care"],
//       image: doctorHomeImages.doctor4
//     },
//     {
//       name: "Dr. Paul Rodriguez",
//       specialization: "Rehabilitation Specialist",
//       degree: "PhD (Rehabilitation)",
//       experience: "15 years of experience",
//       tags: ["Post-Surgical Rehabilitation", "Joint Pain Management", "Mobility Recovery"],
//       image: doctorHomeImages.doctor5
//     },
//     {
//       name: "Dr. Sophia Lee",
//       specialization: "Physical Therapist",
//       degree: "DPT (Physical Therapy)",
//       experience: "12 years of experience",
//       tags: ["Post-Surgery Recovery", "Total Joint Replacement", "Mobility Improvement"],
//       image: doctorHomeImages.doctor6
//     }
//   ]
// },
// {
//   id: "youth-sports-performance",
//   title: "Youth Sports Performance",
//   captionDescription: "Improve athletic skills and strength.",
//   description: "Youth Sports Performance focuses on enhancing the athletic abilities of young athletes through tailored training programs. These programs aim to improve strength, endurance, flexibility, and coordination, helping young athletes reach their full potential. Whether recovering from an injury or looking to enhance performance, youth athletes benefit from personalized coaching that emphasizes injury prevention, physical conditioning, and mental toughness.",
//   image: specImages.spec_mckinze,
//   link: "/services/youth-sports-performance",
//   symptoms: [
//     { title: "Muscle Weakness", description: "Lack of muscle strength impacting athletic performance." },
//     { title: "Decreased Stamina", description: "Low endurance affecting the ability to sustain activity." },
//     { title: "Poor Flexibility", description: "Limited range of motion reducing performance in sports." },
//     { title: "Coordination Issues", description: "Difficulty in controlling movements, impacting sports skills." },
//     { title: "Injury Recovery", description: "Slow recovery from sports-related injuries affecting performance." },
//     { title: "Mental Barriers", description: "Anxiety or fear affecting confidence during sports activities." }
//   ],
//   howItWorks: {
//     description: "Youth Sports Performance programs combine strength and conditioning exercises with sport-specific training to enhance athletic abilities. The program begins with a comprehensive assessment of the athlete's physical condition, followed by personalized exercises targeting areas like strength, agility, and endurance. In addition, mental conditioning is incorporated to help young athletes develop the mental resilience needed for competitive sports. The ultimate goal is to improve overall performance while reducing the risk of injury through proper training techniques.",
//     image: specImages.youthSportsPerformanceHowItWorks
//   },
//   relatedConditions: [
//     { id: "sports-injuries", title: "Sports Injuries", link: "/services/sports-injuries" },
//     { id: "muscle-strain", title: "Muscle Strain", link: "/services/muscle-strain" },
//     { id: "strength-training", title: "Strength Training", link: "/services/strength-training" }
//   ],
//   doctors: [
//     {
//       name: "Dr. Emily Watson",
//       specialization: "Sports Performance Coach",
//       degree: "M.Sc (Sports Science)",
//       experience: "10 years of experience",
//       tags: ["Youth Sports", "Strength Training", "Injury Prevention"],
//       image: doctorHomeImages.doctor7
//     },
//     {
//       name: "Dr. Andrew Lee",
//       specialization: "Physical Therapist",
//       degree: "DPT (Physical Therapy)",
//       experience: "12 years of experience",
//       tags: ["Youth Sports Recovery", "Performance Enhancement", "Injury Rehabilitation"],
//       image: doctorHomeImages.doctor8
//     },
//     {
//       name: "Dr. Rachel Adams",
//       specialization: "Sports Psychologist",
//       degree: "PhD (Sports Psychology)",
//       experience: "8 years of experience",
//       tags: ["Mental Conditioning", "Sports Anxiety", "Performance Psychology"],
//       image: doctorHomeImages.doctor9
//     }
//   ]
// }

//   ];
  